// @ts-nocheck
import { createIcon } from "@chakra-ui/icons";
import React from "react";

export const TuteriaPaymentIcon = () => (
  <svg width="112" height="112" xmlns="http://www.w3.org/2000/svg">
    <g fill="#36B37E" fillRule="nonzero">
      <path d="M89.487 28.875c-5.48 0-9.64-3.197-14.045-6.58C70.382 18.406 64.647 14 56.122 14c-8.526 0-14.26 4.407-19.32 8.294-4.405 3.384-8.565 6.58-14.046 6.58-.97 0-1.756.784-1.756 1.75 0 20.434 2.554 34.04 8.28 44.116 5.686 10.006 14.15 16.229 25.964 23.026a1.759 1.759 0 0 0 1.756 0c11.813-6.797 20.277-13.02 25.963-23.026 5.727-10.076 8.28-23.682 8.28-44.115 0-.967-.786-1.75-1.756-1.75zM56.122 94.227c-21.183-12.31-31.327-22.914-31.604-61.94 5.786-.581 10.173-3.952 14.428-7.221 4.841-3.72 9.847-7.566 17.176-7.566 7.328 0 12.334 3.846 17.176 7.566 4.254 3.27 8.641 6.64 14.427 7.22-.277 39.027-10.42 49.631-31.603 61.94z" />
      <path d="M35.696 34.17c-.457-.943-1.529-1.305-2.395-.808-.22.126-.444.25-.668.37-.878.47-1.24 1.627-.807 2.583.308.682.937 1.077 1.591 1.077.263 0 .53-.063.782-.198.253-.136.505-.276.754-.418.866-.497 1.199-1.663.743-2.606zM80.965 48.018c.048.005.096.007.143.007.803 0 1.489-.698 1.562-1.627.019-.228.036-.457.053-.686.073-.984-.568-1.85-1.432-1.933-.863-.085-1.624.647-1.697 1.631l-.052.664c-.078.984.559 1.855 1.423 1.944zM38.674 34.203c.346 0 .696-.111.998-.342.99-.754 1.953-1.529 2.885-2.279 4.36-3.505 8.124-6.532 12.92-6.532.944 0 1.709-.807 1.709-1.803 0-.996-.765-1.804-1.708-1.804-5.95 0-10.34 3.53-14.99 7.27-.915.735-1.861 1.496-2.815 2.223-.765.584-.937 1.71-.385 2.518.334.489.856.749 1.386.749zM56.02 85.72c-4.452-2.74-9.829-6.42-13.86-11.166a1.742 1.742 0 0 0-2.452-.201 1.735 1.735 0 0 0-.202 2.448c4.632 5.453 10.776 9.513 15.612 12.44l.027.015c.042.024.084.045.128.065.028.014.055.028.084.04.039.016.078.028.119.041.033.012.066.024.1.033.037.01.074.016.11.023.037.007.074.016.112.021.053.007.105.008.159.01.02.001.04.005.061.005h.004c.02 0 .04-.004.06-.004.054-.003.107-.004.16-.011.037-.005.074-.014.11-.021.038-.007.075-.013.112-.023.033-.009.066-.021.1-.032.04-.013.08-.026.12-.042.028-.011.055-.026.083-.04.043-.02.086-.041.128-.065l.027-.014c4.835-2.928 10.98-6.988 15.612-12.441 5.282-6.22 8.611-14.637 10.178-25.733a1.739 1.739 0 1 0-3.445-.485C77.793 61.01 74.723 68.85 69.88 74.555 65.85 79.3 60.473 82.98 56.02 85.72z" />
      <path d="M66.75 35.883L48.71 54.344l-4.281-4.38a5.519 5.519 0 0 0-3.975-1.68 5.52 5.52 0 0 0-3.975 1.68c-2.191 2.243-2.191 5.892 0 8.135l8.268 8.46.072.072.032.031.072.07.04.035.074.067.034.03.076.064.026.022.076.063.043.034.079.06.033.025.079.057.035.025.08.056.04.026.08.053.034.021.082.051.033.02.083.05.05.027.084.046.026.014.086.045.045.023.086.042.036.017.044.02c.031.016.062.03.094.043l.088.037.024.01.089.035.04.016.09.033.043.015.043.015c.03.011.059.021.09.03l.09.029.038.011.09.026.039.01.091.024.037.01.092.021.039.01.091.019.053.01.045.008.083.015.092.014.041.006.093.013.04.004.044.005.087.01.094.008c.018.001.035.003.053.003l.044.003.086.005.094.003h.028l.093.002h.05l.094-.001.028-.001.093-.003.087-.005.044-.003.054-.003.093-.008.086-.01.044-.004a1.42 1.42 0 0 0 .038-.005l.094-.012.043-.007.093-.014c.028-.004.056-.01.084-.016l.044-.008a.761.761 0 0 0 .052-.01l.09-.019.036-.008.093-.021.043-.011.091-.024a.815.815 0 0 0 .036-.01l.09-.026a1.24 1.24 0 0 0 .038-.011l.09-.028a1.81 1.81 0 0 0 .084-.029l.045-.015a2.31 2.31 0 0 0 .047-.017l.09-.033.04-.016.088-.035a.912.912 0 0 0 .03-.012l.087-.037a1.63 1.63 0 0 0 .083-.038l.045-.02.043-.02.086-.042.034-.018.085-.044.082-.044.044-.024.037-.022.084-.048.04-.025.082-.05.038-.025.081-.054a.517.517 0 0 0 .027-.018l.081-.055.042-.03.079-.058.04-.03.078-.06.028-.022.077-.063.06-.05.043-.037.045-.04.074-.066.029-.027.073-.069.031-.03.072-.072.046-.047 21.987-22.5c2.191-2.244 2.19-5.894-.001-8.136a5.517 5.517 0 0 0-3.974-1.68 5.52 5.52 0 0 0-3.975 1.68zm5.504 5.632L50.238 64.044l-.011.012-.16.146-.006.005-.206.149-.292.155-.003.001-.193.073-.006.002-.299.071-.01.002-.15.019-.011.001-.085.005h-.01l-.087.003-.054-.001h-.03l-.012-.002-.086-.005-.01-.001-.149-.018-.013-.003-.297-.071h-.002l-.17-.063-.324-.17-.3-.23-8.337-8.528a2.254 2.254 0 0 1 0-3.13 2.122 2.122 0 0 1 1.53-.643c.58 0 1.123.228 1.528.643l5.504 5.632c.324.332.764.519 1.222.519.459 0 .899-.187 1.223-.518l19.264-19.714a2.121 2.121 0 0 1 1.528-.643c.58 0 1.124.229 1.53.644a2.253 2.253 0 0 1 0 3.129z" />
    </g>
  </svg>
);
export const TuteriaTeachIcon = () => (
  <svg width="112" height="112" xmlns="http://www.w3.org/2000/svg">
    <g fill="#36B37E" fillRule="nonzero">
      <path d="M48 59c-1.105 0-2 .886-2 1.978v.044A1.99 1.99 0 0 0 48 63c1.105 0 2-.886 2-1.978v-.044A1.99 1.99 0 0 0 48 59zM73 47c-1.105 0-2 .886-2 1.978v.044A1.99 1.99 0 0 0 73 51c1.105 0 2-.886 2-1.978v-.044A1.99 1.99 0 0 0 73 47zM40 75c-1.105 0-2 .886-2 1.978v.044A1.99 1.99 0 0 0 40 79c1.105 0 2-.886 2-1.978v-.044A1.99 1.99 0 0 0 40 75z" />
      <path d="M97.245 90.485h-5.792V38.29c0-.97-.786-1.758-1.755-1.758H72.705c-.97 0-1.755.787-1.755 1.758v4.242a1.756 1.756 0 1 0 3.51 0v-2.485h13.483v50.438H74.46V54.95a1.756 1.756 0 1 0-3.51 0v35.535h-4.694V46.033c0-.97-.786-1.757-1.755-1.757H47.508c-.97 0-1.755.787-1.755 1.757v8.818a1.756 1.756 0 1 0 3.51 0v-7.06h13.483v42.694H49.263V66.918a1.756 1.756 0 1 0-3.51 0v23.567h-4.694v-8.142a1.756 1.756 0 1 0-3.51 0v8.142H24.066V56.567h13.483v13.59a1.756 1.756 0 1 0 3.51 0V54.81c0-.97-.786-1.757-1.755-1.757H22.31c-.97 0-1.755.787-1.755 1.757v35.676H16.51V24.757a1.756 1.756 0 1 0-3.51 0v67.486c0 .97.786 1.757 1.755 1.757h82.49a1.757 1.757 0 1 0 0-3.515z" />
      <path d="M92.896 22.47a1.74 1.74 0 0 0-1.154-1.075l-8.054-2.325a1.75 1.75 0 0 0-2.168 1.176 1.728 1.728 0 0 0 1.189 2.146l1.96.566-62.324 14.628a1.73 1.73 0 0 0-1.297 2.083 1.745 1.745 0 0 0 2.103 1.284l64.032-15.03-1.966 2.877a1.72 1.72 0 0 0 .468 2.403c.3.2.641.297.978.297a1.75 1.75 0 0 0 1.45-.76l4.587-6.715a1.715 1.715 0 0 0 .196-1.556z" />
    </g>
  </svg>
);

export const LoveIcon = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 38 35"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Shape</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g
        id="External-Pages"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Become-a-Tutor-Landing-Page---Desktop"
          transform="translate(-1093.000000, -1304.000000)"
          fillRule="nonzero"
          fill="#FF4F4F"
        >
          <path
            d="M1127.75417,1307.278 C1125.65942,1305.16512 1122.8775,1304 1119.91667,1304 C1116.95583,1304 1114.17392,1305.16512 1112.08075,1307.27641 C1112.05383,1307.30358 1112.02692,1307.33075 1112,1307.35951 C1111.97308,1307.33075 1111.94775,1307.30517 1111.92083,1307.278 C1109.82608,1305.16512 1107.04417,1304 1104.08333,1304 C1101.1225,1304 1098.34058,1305.16512 1096.24583,1307.278 C1094.15108,1309.39089 1093,1312.199 1093,1315.18773 C1093,1318.17645 1094.15267,1320.98457 1096.24583,1323.09745 L1112,1339 L1127.75417,1323.09745 C1129.84733,1320.98457 1131,1318.17645 1131,1315.18773 C1131,1312.2006 1129.84733,1309.39089 1127.75417,1307.278 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const TuteriaTrust = () => (
  <svg width="112" height="112" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(6 14)" fill="#36B37E" fillRule="nonzero">
      <path d="M59.98 72.997h-7.616c-1.084 0-1.963.87-1.963 1.945 0 1.074.88 1.945 1.963 1.945h7.616c1.176 0 2.132.947 2.132 2.112a2.124 2.124 0 0 1-2.132 2.112H39.478c-3.082 0-5.98-1.347-7.951-3.694l-4.903-5.839a14.272 14.272 0 0 0-10.557-5.084V55.006h7.227c3.565 0 6.94 1.35 9.503 3.803l10.582 10.12c.748.715.783 1.913.078 2.67a1.945 1.945 0 0 1-2.72.113l-8.308-7.546a1.975 1.975 0 0 0-2.773.12 1.932 1.932 0 0 0 .12 2.747l8.308 7.546a5.862 5.862 0 0 0 3.953 1.52 5.867 5.867 0 0 0 4.305-1.862c2.14-2.298 2.035-5.934-.236-8.106L35.523 56.01a17.609 17.609 0 0 0-12.229-4.894h-7.608a4.874 4.874 0 0 0-4.484-2.95h-9.24C.88 48.167 0 49.037 0 50.11v14.22c0 1.075.879 1.945 1.963 1.945s1.963-.87 1.963-1.944V52.056h7.276c.519 0 .94.418.94.93v15.588a.936.936 0 0 1-.94.93H9.164c-1.084 0-1.963.871-1.963 1.945s.879 1.945 1.963 1.945h2.038c2.04 0 3.79-1.252 4.512-3.02 3.06.017 5.934 1.36 7.892 3.692l4.903 5.838A14.282 14.282 0 0 0 39.478 85H59.98c3.34 0 6.058-2.692 6.058-6.001 0-3.31-2.718-6.002-6.058-6.002zM98.037 17.964c-1.084 0-1.963.87-1.963 1.945v13.035h-7.276a.936.936 0 0 1-.94-.93V16.425c0-.513.421-.93.94-.93h1.894c1.084 0 1.963-.871 1.963-1.945a1.954 1.954 0 0 0-1.963-1.945h-1.894a4.872 4.872 0 0 0-4.513 3.02 10.351 10.351 0 0 1-7.892-3.691l-4.903-5.84A14.282 14.282 0 0 0 60.522 0H40.02c-3.34 0-6.058 2.692-6.058 6.001 0 3.31 2.718 6.001 6.058 6.001h8.383c1.084 0 1.963-.87 1.963-1.944a1.954 1.954 0 0 0-1.963-1.945H40.02A2.124 2.124 0 0 1 37.888 6c0-1.164.956-2.112 2.132-2.112h20.502c3.082 0 5.98 1.346 7.95 3.694l4.904 5.838a14.272 14.272 0 0 0 10.556 5.085v11.488h-7.227c-3.564 0-6.938-1.35-9.502-3.803L56.62 16.071a1.909 1.909 0 0 1-.078-2.67 1.945 1.945 0 0 1 2.72-.113l8.308 7.545c.8.726 2.04.673 2.773-.119a1.932 1.932 0 0 0-.12-2.748l-8.309-7.545c-2.37-2.153-6.075-2-8.257.342-2.14 2.298-2.035 5.934.236 8.106l10.582 10.12a17.609 17.609 0 0 0 12.23 4.894h7.608a4.874 4.874 0 0 0 4.484 2.95h9.24c1.083 0 1.962-.87 1.962-1.944v-14.98a1.954 1.954 0 0 0-1.963-1.945zM63.041 66.276a1.871 1.871 0 0 0-2.48-.942 1.886 1.886 0 0 0 .75 3.61c.251 0 .505-.05.75-.157l.04-.018a1.889 1.889 0 0 0 .94-2.493zM67.555 63.098a1.885 1.885 0 0 0-2.634-.398 1.892 1.892 0 0 0-.407 2.638 1.877 1.877 0 0 0 2.63.409l.024-.018a1.884 1.884 0 0 0 .387-2.63z" />
      <path d="M57.506 68.552a1.88 1.88 0 0 0-2.22-1.457 1.887 1.887 0 0 0-1.479 2.205 1.881 1.881 0 0 0 2.253 1.488 1.885 1.885 0 0 0 1.446-2.236zM72.02 59.04a1.88 1.88 0 0 0-2.695.182 1.883 1.883 0 0 0 1.423 3.111c.522 0 1.041-.216 1.412-.638.693-.772.63-1.96-.14-2.655zm-1.05 1.587l-.209-.19.226.205-.017-.015zM76.963 48.248a1.888 1.888 0 0 0-2.35 1.26 1.882 1.882 0 0 0 1.8 2.436c.805 0 1.55-.52 1.8-1.329l.008-.025a1.877 1.877 0 0 0-1.258-2.342zM79.215 38.4a1.884 1.884 0 0 0-2.243-1.526 1.881 1.881 0 0 0-1.463 2.212 1.884 1.884 0 0 0 2.183 1.495 1.88 1.88 0 0 0 1.523-2.182zM77.525 42.507a1.886 1.886 0 0 0-2.05 1.78 1.882 1.882 0 0 0 1.884 1.99c.982 0 1.807-.756 1.88-1.741a1.882 1.882 0 0 0-1.714-2.029zM74.518 54.077a1.885 1.885 0 0 0-2.565.707l-.026.047a1.88 1.88 0 0 0 3.298 1.805l-1.635-.927 1.637.925a1.872 1.872 0 0 0-.71-2.557zM39.424 17.1a1.878 1.878 0 0 0-2.524-.845l-.017.009a1.883 1.883 0 0 0-.833 2.528 1.882 1.882 0 0 0 2.532.84c.93-.465 1.306-1.6.842-2.532zM45.23 14.664a1.874 1.874 0 0 0-2.309-1.377 1.89 1.89 0 0 0-1.352 2.297 1.876 1.876 0 0 0 2.28 1.356 1.886 1.886 0 0 0 1.38-2.276zM34.49 19.59a1.88 1.88 0 0 0-2.643-.286l1.165 1.478-1.171-1.474a1.887 1.887 0 0 0-.3 2.648 1.876 1.876 0 0 0 2.642.3l.025-.02a1.885 1.885 0 0 0 .281-2.645zM24.083 33.122a1.884 1.884 0 0 0-2.331 1.39 1.879 1.879 0 0 0 1.832 2.321c.845 0 1.613-.572 1.827-1.425a1.88 1.88 0 0 0-1.328-2.286zM22.751 39.67a1.885 1.885 0 0 0-1.995 1.84 1.882 1.882 0 0 0 1.886 1.934c1.011 0 1.847-.8 1.884-1.812a1.883 1.883 0 0 0-1.775-1.962zM26.35 28.55a1.883 1.883 0 0 0-2.54.79l-.032.061a1.879 1.879 0 0 0 1.688 2.71c.69 0 1.356-.382 1.686-1.04a1.88 1.88 0 0 0-.802-2.522zM29.51 23.1a1.88 1.88 0 0 0-2.65.247l-.039.048a1.882 1.882 0 0 0 2.944 2.344c.652-.8.54-1.977-.256-2.638zM24.498 46.885a1.886 1.886 0 0 0-3.713.665l.003.018a1.875 1.875 0 0 0 2.188 1.513 1.892 1.892 0 0 0 1.522-2.196zM56.071 32.111a8.944 8.944 0 0 0-6.543 2.84 8.945 8.945 0 0 0-6.542-2.84c-4.976 0-9.024 4.1-9.024 9.14a9.168 9.168 0 0 0 3.287 7.055l11.073 8.88a1.923 1.923 0 0 0 2.417-.004L62.28 47.87c.057-.045.11-.094.162-.146a9.138 9.138 0 0 0 2.651-6.471c0-5.04-4.047-9.14-9.023-9.14zm3.698 12.753L49.525 53.13l-9.843-7.894a5.221 5.221 0 0 1-1.833-3.984c0-2.87 2.304-5.204 5.137-5.204 2.085 0 3.949 1.261 4.747 3.214a1.943 1.943 0 0 0 1.795 1.215c.786 0 1.494-.48 1.795-1.215.8-1.953 2.663-3.214 4.748-3.214 2.833 0 5.137 2.334 5.137 5.204 0 1.358-.51 2.637-1.44 3.612z" />
      <ellipse cx="1.887" cy="70.833" rx="1.887" ry="1.889" />
      <ellipse cx="98.113" cy="13.222" rx="1.887" ry="1.889" />
    </g>
  </svg>
);
export const BBCIcon = () => (
  <svg
    version="1.0"
    width="240.000000pt"
    height="70.000000pt"
    viewBox="0 0 240.000000 70.000000"
  >
    <g
      transform="translate(0.000000,70.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M0 350 l0 -350 365 0 365 0 0 350 0 350 -365 0 -365 0 0 -350z m437
229 c48 -23 73 -61 73 -109 0 -34 -23 -85 -42 -94 -11 -5 -10 -7 0 -12 32 -15
72 -58 82 -89 21 -65 -23 -138 -99 -164 -19 -6 -85 -11 -147 -11 l-114 0 0
250 0 250 102 0 c83 0 110 -4 145 -21z"
      />
      <path
        d="M280 454 l0 -67 51 6 c61 7 89 29 89 68 0 38 -33 59 -92 59 l-48 0 0
-66z"
      />
      <path
        d="M280 244 l0 -66 75 4 c78 4 97 13 110 55 4 17 -1 29 -19 48 -22 22
-34 25 -96 25 l-70 0 0 -66z"
      />
      <path
        d="M840 350 l0 -350 360 0 360 0 0 350 0 350 -360 0 -360 0 0 -350z
m430 228 c81 -41 100 -121 44 -187 l-24 -29 30 -12 c63 -26 88 -115 50 -177
-33 -55 -69 -67 -212 -71 l-128 -4 0 251 0 251 98 0 c82 0 105 -4 142 -22z"
      />
      <path
        d="M1120 455 l0 -65 30 0 c17 0 46 7 65 14 32 14 35 19 35 55 0 48 -18
61 -84 61 l-46 0 0 -65z"
      />
      <path
        d="M1120 245 l0 -65 64 0 c73 0 116 24 116 66 0 45 -32 64 -110 64 l-70
0 0 -65z"
      />
      <path
        d="M1670 350 l0 -350 365 0 365 0 0 350 0 350 -365 0 -365 0 0 -350z
m525 231 c50 -16 50 -16 53 -63 l3 -47 -45 20 c-111 49 -210 42 -277 -18 -60
-55 -74 -126 -38 -200 45 -94 168 -123 297 -70 l63 25 -3 -46 c-3 -46 -4 -47
-53 -65 -58 -22 -170 -26 -232 -8 -61 17 -123 68 -152 126 -32 62 -35 160 -7
215 71 136 221 187 391 131z"
      />
    </g>
  </svg>
);

export const FacebookIcon = () => (
  <svg
    version="1.0"
    width="262.000000pt"
    height="54.000000pt"
    viewBox="0 0 262.000000 54.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,54.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M120 527 c-43 -15 -70 -63 -70 -124 0 -39 -2 -43 -25 -43 -22 0 -25
  -4 -25 -40 0 -36 3 -40 25 -40 l25 0 0 -135 0 -135 55 0 55 0 0 135 0 135 35
  0 c27 0 35 4 35 18 0 9 3 27 6 40 6 20 3 22 -35 22 l-42 0 3 43 c3 41 4 42 41
  45 37 3 37 4 37 48 l0 44 -42 -1 c-24 0 -59 -5 -78 -12z"
      />
      <path
        d="M1268 513 l-28 -4 0 -244 0 -244 38 -8 c63 -14 174 -8 209 10 56 30
  63 49 63 175 0 108 -1 114 -26 138 -23 24 -30 26 -105 22 l-79 -3 0 82 c0 92
  4 87 -72 76z m170 -245 c7 -7 12 -40 12 -79 0 -80 -13 -99 -71 -99 l-39 0 0
  85 c0 69 3 86 18 94 23 14 65 14 80 -1z"
      />
      <path
        d="M2333 513 l-33 -4 0 -250 0 -249 55 0 54 0 3 80 3 80 49 -80 48 -80
  54 0 c30 0 54 2 54 4 0 3 -22 41 -50 85 -27 44 -50 85 -50 90 0 4 23 43 50 85
  28 42 50 79 50 81 0 3 -24 5 -54 5 l-55 0 -48 -77 -48 -78 -3 158 c-3 176 6
  160 -79 150z"
      />
      <path
        d="M278 320 l-4 -40 51 -1 c81 -2 100 -10 100 -44 0 -30 0 -30 -71 -35
  -92 -6 -114 -24 -114 -89 0 -89 60 -126 153 -96 35 11 53 13 55 6 2 -6 21 -11
  43 -11 l39 0 0 138 c0 90 -5 146 -13 162 -17 33 -66 49 -158 49 l-77 1 -4 -40z
  m152 -204 c0 -25 -16 -36 -56 -36 -26 0 -40 20 -30 45 3 10 19 15 46 15 36 0
  40 -3 40 -24z"
      />
      <path
        d="M639 337 c-51 -35 -60 -60 -57 -164 3 -86 5 -94 32 -122 45 -47 131
  -61 219 -35 12 4 17 16 17 44 l0 39 -68 -6 c-89 -7 -102 4 -102 92 0 88 13 99
  102 92 l68 -6 0 39 c0 46 -8 50 -104 50 -59 0 -79 -4 -107 -23z"
      />
      <path
        d="M944 341 c-45 -27 -57 -65 -53 -170 4 -83 6 -92 32 -119 37 -38 102
  -57 171 -48 80 9 86 13 86 55 l0 38 -78 -5 c-84 -5 -112 7 -112 49 0 17 8 19
  100 19 l100 0 0 63 c0 70 -14 98 -60 122 -42 22 -147 20 -186 -4z m134 -63 c7
  -7 12 -22 12 -35 0 -21 -4 -23 -50 -23 -43 0 -50 3 -50 19 0 41 59 68 88 39z"
      />
      <path
        d="M1650 338 c-46 -31 -63 -82 -57 -175 6 -113 50 -157 157 -157 68 -1
  118 25 142 74 22 43 24 156 4 203 -24 57 -50 72 -135 75 -67 3 -80 1 -111 -20z
  m138 -70 c7 -7 12 -41 12 -83 0 -78 -9 -95 -50 -95 -41 0 -50 17 -50 95 0 78
  9 95 50 95 14 0 31 -5 38 -12z"
      />
      <path
        d="M2013 345 c-48 -20 -63 -60 -63 -160 0 -100 14 -135 62 -158 58 -26
  95 -29 153 -12 78 22 95 52 95 168 0 100 -14 138 -60 162 -36 19 -144 19 -187
  0z m131 -81 c11 -11 16 -35 16 -79 0 -70 -14 -95 -55 -95 -41 0 -55 25 -55 95
  0 70 14 95 55 95 13 0 31 -7 39 -16z"
      />
    </g>
  </svg>
);

export const RoyalIcon = () => (
  <svg
    version="1.0"
    width="280.000000pt"
    height="100.000000pt"
    viewBox="0 0 280.000000 100.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M298 984 c-185 -44 -290 -167 -291 -339 -1 -161 107 -381 262 -537
 65 -64 86 -79 133 -93 50 -14 60 -14 91 -2 49 21 73 58 108 166 62 194 99 399
 99 549 0 74 -4 96 -25 139 -55 109 -211 158 -377 117z m200 -36 c43 -13 92
 -55 107 -93 23 -54 27 -137 15 -315 -22 -353 -53 -470 -124 -470 -20 0 -76 49
 -76 67 0 8 -19 37 -43 63 -95 105 -151 263 -145 405 3 72 7 88 37 136 33 53
 33 55 22 115 -15 83 -15 81 22 93 67 21 114 21 185 -1z"
      />
      <path
        d="M870 695 c0 -57 4 -95 10 -95 6 0 10 16 10 35 0 31 3 35 25 35 17 0
 32 -10 47 -35 13 -19 26 -35 31 -35 12 0 8 10 -14 41 l-20 29 20 26 c26 33 26
 49 1 74 -14 14 -33 20 -65 20 l-45 0 0 -95z m98 63 c28 -28 -1 -68 -49 -68
 -27 0 -29 2 -29 40 0 39 1 40 33 40 18 0 38 -5 45 -12z"
      />
      <path
        d="M1050 768 c-24 -27 -28 -112 -5 -144 18 -26 67 -37 99 -23 48 22 63
 115 25 163 -27 34 -88 37 -119 4z m100 -8 c26 -26 28 -105 3 -132 -20 -22 -61
 -23 -85 -1 -28 25 -25 117 4 137 30 21 54 20 78 -4z"
      />
      <path
        d="M1231 733 c19 -32 36 -76 40 -98 l6 -40 2 39 c1 24 13 58 32 88 16
 28 28 55 26 61 -2 6 -15 -11 -30 -36 -16 -26 -30 -47 -32 -47 -2 0 -16 20 -31
 45 -14 25 -30 45 -36 45 -5 0 5 -26 23 -57z"
      />
      <path
        d="M1403 773 c-3 -10 -19 -51 -35 -91 -31 -81 -32 -82 -19 -82 5 0 14
 14 20 30 9 27 14 30 53 30 39 0 45 -3 55 -30 6 -16 16 -30 21 -30 6 0 -5 41
 -24 91 -19 51 -34 93 -34 95 0 13 -32 1 -37 -13z m25 -91 c-16 -2 -32 -1 -34
 1 -3 2 3 24 12 47 l17 43 18 -44 17 -44 -30 -3z"
      />
      <path
        d="M1536 783 c-3 -3 -6 -46 -6 -95 l0 -88 63 2 c56 1 57 2 15 5 l-48 4
 0 84 c0 77 -7 104 -24 88z"
      />
      <path
        d="M892 454 c-33 -93 -38 -144 -7 -71 13 33 19 37 51 37 31 0 37 -4 50
 -35 8 -19 18 -35 22 -35 5 0 -7 45 -26 100 -19 55 -40 100 -46 100 -6 0 -26
 -43 -44 -96z m67 -6 c1 -13 -7 -18 -24 -18 -28 0 -30 7 -13 63 l12 40 12 -34
 c7 -19 13 -42 13 -51z"
      />
      <path
        d="M1061 531 c-40 -40 -38 -138 2 -166 12 -9 41 -14 67 -14 l45 2 -47 6
 c-60 9 -70 18 -75 78 -7 64 18 97 71 97 20 0 36 4 36 8 0 17 -80 8 -99 -11z"
      />
      <path
        d="M1223 457 c-36 -102 -37 -107 -24 -107 4 0 12 15 17 33 9 29 14 32
 50 35 38 3 41 1 50 -29 5 -18 15 -34 21 -36 7 -3 -2 36 -22 92 -19 54 -35 99
 -35 101 0 2 -6 4 -12 4 -7 0 -28 -42 -45 -93z m77 -24 c0 -2 -13 -3 -30 -3
 -33 0 -35 6 -18 62 l11 39 19 -48 c10 -26 18 -49 18 -50z"
      />
      <path
        d="M1380 450 l0 -100 48 0 c26 0 57 7 69 15 45 32 37 151 -12 173 -14 7
 -44 12 -65 12 l-40 0 0 -100z m114 58 c9 -12 16 -38 16 -58 0 -54 -23 -80 -71
 -80 l-39 0 0 80 0 80 39 0 c30 0 44 -6 55 -22z"
      />
      <path
        d="M1560 450 l0 -100 61 0 c37 0 58 4 54 10 -3 6 -26 10 -51 10 -44 0
 -44 0 -44 35 0 35 0 35 45 35 25 0 45 5 45 10 0 6 -20 10 -45 10 -45 0 -45 0
 -45 35 l0 35 50 0 c28 0 50 5 50 10 0 6 -27 10 -60 10 l-60 0 0 -100z"
      />
      <path
        d="M1720 450 c0 -60 4 -100 10 -100 6 0 10 32 10 75 0 41 4 75 8 75 5 0
 17 -18 27 -40 24 -53 45 -51 76 8 l24 47 3 -82 c2 -47 7 -83 13 -83 15 0 7
 192 -8 197 -7 3 -24 -20 -40 -51 -15 -31 -30 -56 -33 -56 -3 0 -18 25 -35 55
 -44 82 -55 74 -55 -45z"
      />
      <path
        d="M1930 543 c0 -5 14 -30 30 -58 20 -34 30 -64 30 -92 0 -24 5 -43 10
 -43 6 0 10 16 10 36 0 22 13 60 36 100 20 35 32 64 27 64 -4 0 -21 -23 -36
 -51 -32 -57 -42 -55 -72 11 -16 35 -35 53 -35 33z"
      />
      <path
        d="M2185 525 c-38 -37 -32 -140 9 -167 6 -4 28 -8 49 -8 31 0 40 5 57
 33 23 36 25 70 9 116 -19 55 -82 69 -124 26z m86 -4 c30 -24 33 -109 4 -141
 -42 -46 -95 -8 -95 68 0 49 13 75 40 85 24 9 27 8 51 -12z"
      />
      <path
        d="M2360 450 c0 -60 4 -100 10 -100 6 0 10 20 10 45 l0 45 45 0 c25 0
 45 5 45 10 0 6 -20 10 -45 10 -45 0 -45 0 -45 35 0 35 0 35 45 35 25 0 45 5
 45 10 0 6 -25 10 -55 10 l-55 0 0 -100z"
      />
      <path
        d="M870 195 l0 -106 68 3 c52 2 67 6 67 18 0 10 -13 16 -42 18 -38 3
 -43 6 -43 28 0 21 4 24 40 24 33 0 40 3 40 20 0 17 -7 20 -40 20 -33 0 -40 3
 -40 19 0 16 8 20 42 23 31 2 44 8 46 21 3 15 -5 17 -67 17 l-71 0 0 -105z"
      />
      <path
        d="M1042 198 c3 -98 4 -103 26 -106 21 -3 22 0 22 58 0 34 4 59 9 56 5
 -3 23 -31 40 -61 25 -44 36 -55 56 -55 l25 0 0 105 0 105 -26 0 c-25 0 -26 -1
 -22 -59 1 -33 1 -57 -2 -55 -3 3 -19 29 -36 57 -25 43 -36 53 -62 55 l-33 3 3
 -103z"
      />
      <path
        d="M1286 287 c-39 -29 -39 -155 1 -185 11 -8 40 -12 78 -10 l60 3 3 52
 c3 44 0 52 -17 58 -30 9 -41 -2 -41 -41 0 -33 -2 -35 -27 -32 -27 3 -28 5 -28
 63 l0 60 53 3 c44 3 52 6 52 23 0 17 -7 19 -58 19 -32 0 -66 -6 -76 -13z"
      />
      <path d="M1460 195 l0 -105 25 0 25 0 0 105 0 105 -25 0 -25 0 0 -105z" />
      <path
        d="M1550 195 c0 -105 0 -105 25 -105 23 0 24 4 27 62 l3 63 33 -62 c29
 -56 36 -63 62 -63 l30 0 0 105 c0 105 0 105 -25 105 -23 0 -24 -4 -27 -62 l-3
 -63 -35 63 c-29 53 -39 62 -62 62 l-28 0 0 -105z"
      />
      <path
        d="M1770 195 l0 -105 71 0 c62 0 70 2 67 18 -2 12 -15 18 -46 20 -37 3
 -42 6 -42 28 0 21 4 24 40 24 33 0 40 3 40 20 0 17 -7 20 -40 20 -33 0 -40 3
 -40 19 0 16 8 20 42 23 31 2 44 8 46 21 3 15 -5 17 -67 17 l-71 0 0 -105z"
      />
      <path
        d="M1940 195 l0 -105 75 0 c68 0 75 2 75 19 0 17 -8 20 -47 23 -40 3
 -48 6 -48 23 0 16 8 21 43 23 34 3 42 7 42 23 0 16 -7 19 -45 19 -38 0 -45 3
 -45 19 0 17 8 20 47 23 36 2 49 7 51 21 3 15 -6 17 -72 17 l-76 0 0 -105z"
      />
      <path
        d="M2122 198 c3 -102 3 -103 28 -103 21 0 26 5 28 33 4 43 28 42 49 -3
 13 -28 22 -35 46 -35 l29 0 -22 35 c-21 34 -21 37 -6 76 13 32 14 45 5 62 -18
 33 -28 37 -97 37 l-63 0 3 -102z m111 50 c7 -23 -4 -38 -29 -38 -19 0 -24 5
 -24 25 0 20 5 25 24 25 13 0 26 -6 29 -12z"
      />
      <path d="M2320 195 l0 -105 30 0 30 0 0 105 0 105 -30 0 -30 0 0 -105z" />
      <path
        d="M2412 198 c3 -98 4 -103 26 -106 21 -3 22 0 22 65 l0 68 37 -67 c32
 -59 41 -68 65 -68 l28 0 0 105 0 105 -25 0 c-24 0 -25 -3 -25 -62 l-1 -63 -35
 63 c-31 54 -40 62 -65 62 l-30 0 3 -102z"
      />
      <path
        d="M2662 293 c-38 -15 -54 -111 -27 -162 18 -35 32 -41 101 -41 l54 0 0
 60 c0 52 -2 60 -19 60 -21 0 -31 -19 -31 -56 0 -22 -4 -25 -27 -22 -27 3 -28
 5 -28 63 l0 60 53 3 c44 3 52 6 52 23 0 17 -7 19 -57 18 -32 0 -64 -3 -71 -6z"
      />
    </g>
  </svg>
);
export const ForbesIcon = () => (
  <svg
    version="1.0"
    width="226.000000pt"
    height="60.000000pt"
    viewBox="0 0 226.000000 60.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,60.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M1182 575 c-71 -14 -86 -23 -53 -32 12 -3 27 -17 32 -30 5 -13 9
-129 9 -257 l0 -233 73 -13 c121 -20 214 16 258 103 81 157 -19 341 -166 307
-22 -5 -43 -10 -47 -10 -5 0 -8 41 -8 90 0 102 8 96 -98 75z m187 -214 c66
-66 45 -281 -31 -319 -55 -26 -58 -16 -58 169 l0 169 35 0 c21 0 43 -8 54 -19z"
      />
      <path
        d="M0 571 c0 -5 13 -11 29 -14 51 -11 56 -33 56 -247 0 -107 -4 -208 -8
-223 -5 -19 -19 -33 -42 -43 -19 -8 -35 -16 -35 -19 0 -3 68 -5 150 -5 93 0
150 4 150 10 0 6 -11 10 -25 10 -41 0 -59 40 -63 147 l-4 94 48 -3 c45 -3 51
-6 69 -40 11 -21 23 -38 28 -38 4 0 7 43 7 95 0 94 -11 121 -29 72 -13 -33
-35 -48 -81 -54 l-40 -6 0 117 0 116 69 0 c79 0 109 -17 141 -81 11 -21 25
-39 30 -39 6 0 10 34 10 80 l0 80 -230 0 c-126 0 -230 -4 -230 -9z"
      />
      <path
        d="M525 416 c-70 -32 -115 -111 -115 -203 1 -105 52 -177 144 -203 86
-24 179 19 220 102 41 81 31 202 -21 260 -45 51 -161 74 -228 44z m110 -30
c31 -31 45 -85 45 -176 0 -94 -14 -146 -45 -166 -56 -36 -97 20 -103 143 -6
110 4 170 33 199 30 30 40 30 70 0z"
      />
      <path
        d="M883 413 c-40 -9 -73 -19 -73 -24 0 -5 7 -9 15 -9 27 0 35 -38 35
-170 0 -132 -8 -170 -35 -170 -8 0 -15 -4 -15 -10 0 -6 45 -10 115 -10 70 0
115 4 115 10 0 6 -8 10 -19 10 -35 0 -43 26 -49 147 -4 105 -3 117 13 130 22
15 69 17 95 3 16 -8 20 -4 34 37 22 65 21 73 -14 73 -39 0 -86 -24 -100 -50
-16 -31 -26 -24 -22 15 5 40 9 39 -95 18z"
      />
      <path
        d="M1672 409 c-67 -34 -96 -86 -100 -178 -3 -64 1 -83 20 -121 40 -78
135 -123 213 -100 47 14 105 50 105 66 0 8 -12 8 -40 -2 -91 -32 -174 24 -182
121 l-3 40 118 3 117 3 0 32 c0 49 -39 118 -80 139 -47 24 -115 23 -168 -3z
m116 -37 c6 -15 13 -44 17 -64 l6 -38 -65 0 -65 0 6 33 c18 94 76 134 101 69z"
      />
      <path
        d="M2033 416 c-67 -31 -94 -126 -51 -181 12 -15 50 -40 85 -56 75 -34
95 -64 69 -103 -35 -55 -101 -41 -144 29 -15 24 -30 45 -34 45 -5 0 -8 -27 -8
-60 l0 -59 38 -10 c79 -22 101 -23 155 -7 93 27 136 101 100 174 -14 28 -32
44 -80 68 -34 16 -71 38 -83 49 -54 49 13 121 81 85 10 -6 29 -30 41 -53 l23
-42 3 54 c2 30 -1 58 -7 64 -17 17 -152 19 -188 3z"
      />
    </g>
  </svg>
);
export const FuturesIcon = () => (
  <svg
    version="1.0"
    width="308.000000pt"
    height="124.000000pt"
    viewBox="0 0 308.000000 124.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,124.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M625 1060 c3 -5 1 -10 -4 -10 -6 0 -11 -7 -11 -15 0 -8 -4 -15 -10
 -15 -5 0 -10 -6 -10 -13 0 -9 12 -11 40 -9 23 2 39 7 38 11 -2 3 -10 18 -17
 34 -8 15 -18 27 -23 27 -5 0 -6 -4 -3 -10z"
      />
      <path
        d="M419 1038 c-1 -7 -1 -19 0 -25 1 -7 -2 -13 -7 -13 -15 0 -30 -44 -22
 -65 4 -11 5 -26 3 -32 -3 -7 -1 -13 5 -13 6 0 13 6 15 13 3 7 6 5 6 -5 1 -19
 21 -25 21 -7 0 6 6 9 14 6 10 -4 16 5 20 29 7 32 -6 74 -23 74 -4 0 -7 10 -7
 21 1 24 -23 40 -25 17z m31 -53 c16 -20 5 -45 -20 -45 -14 0 -20 7 -20 23 0
 38 18 48 40 22z"
      />
      <path
        d="M744 1005 c-7 -28 7 -77 24 -83 7 -2 12 1 12 7 0 6 -4 11 -10 11 -16
 0 -11 42 7 55 9 7 13 17 9 23 -12 20 -35 13 -42 -13z"
      />
      <path
        d="M256 979 c-31 -24 -32 -49 -6 -106 23 -53 46 -55 66 -7 27 64 28 90
 5 113 -26 26 -32 26 -65 0z"
      />
      <path
        d="M816 948 c8 -52 7 -50 28 -42 11 4 16 14 13 25 -3 11 0 16 8 13 7 -3
 11 -14 8 -25 -6 -20 11 -26 23 -8 4 8 9 7 15 -2 4 -7 10 -11 14 -8 8 9 -82 89
 -100 89 -12 0 -14 -8 -9 -42z"
      />
      <path
        d="M539 954 c-9 -11 -6 -14 20 -14 34 0 42 15 11 23 -10 3 -24 -1 -31
 -9z"
      />
      <path
        d="M1332 868 c3 -88 4 -93 26 -96 20 -3 22 0 22 46 0 32 5 54 15 62 18
 15 23 4 27 -60 3 -37 6 -45 23 -45 17 0 20 8 23 48 2 27 -2 55 -9 63 -14 17
 -51 18 -67 2 -9 -9 -12 -3 -12 30 0 38 -2 42 -25 42 l-26 0 3 -92z"
      />
      <path
        d="M1263 918 c-18 -19 -23 -36 -23 -75 0 -57 16 -79 51 -68 13 4 17 10
 11 14 -6 4 -12 39 -14 80 l-3 73 -22 -24z"
      />
      <path
        d="M1516 885 c-24 -25 -29 -54 -12 -80 16 -24 61 -43 73 -31 4 3 -1 6
 -10 6 -14 0 -17 11 -17 60 0 62 -7 71 -34 45z"
      />
      <path
        d="M1570 870 c0 -25 4 -30 25 -30 30 0 33 20 7 43 -26 24 -32 21 -32
 -13z"
      />
      <path d="M918 863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
      <path d="M813 825 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
      <path d="M728 803 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
      <path
        d="M158 793 c-21 -2 -38 -8 -38 -14 0 -5 -6 -9 -14 -9 -28 0 -24 -37 5
 -54 16 -10 29 -22 29 -28 0 -6 -9 -3 -19 6 -11 10 -26 16 -33 13 -9 -4 -8 -6
 4 -6 24 -1 60 -50 53 -73 -5 -13 -1 -18 13 -18 16 0 18 5 12 48 -4 26 -8 52
 -10 57 -5 20 0 26 13 13 8 -7 34 -13 58 -13 42 0 44 2 47 31 3 28 0 32 -36 42
 -22 7 -41 11 -43 10 -2 -1 -21 -3 -41 -5z"
      />
      <path
        d="M810 755 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0 -4
 -7 -4 -15z"
      />
      <path
        d="M1264 736 c-16 -12 -20 -29 -23 -100 l-3 -86 26 0 c25 0 26 2 27 58
 0 31 1 76 2 100 2 46 0 49 -29 28z"
      />
      <path
        d="M1307 743 c-4 -3 -7 -12 -7 -20 0 -15 26 -18 34 -4 7 11 -18 33 -27
 24z"
      />
      <path
        d="M910 720 c0 -14 7 -20 23 -20 16 0 18 3 8 9 -7 5 -10 14 -7 20 4 6 0
 11 -8 11 -9 0 -16 -9 -16 -20z"
      />
      <path
        d="M2768 650 c-3 -92 0 -100 38 -100 11 0 14 20 14 95 0 94 0 95 -24 95
 -24 0 -25 -2 -28 -90z"
      />
      <path
        d="M740 720 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0 -16
 -4 -16 -10z"
      />
      <path
        d="M1530 697 c-23 -20 -25 -27 -20 -82 5 -55 7 -60 29 -60 24 0 24 1 22
 80 -1 44 -3 81 -4 82 -1 1 -13 -8 -27 -20z"
      />
      <path
        d="M180 690 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
 -4 -4 -10z"
      />
      <path
        d="M765 690 c3 -5 15 -10 26 -10 11 0 17 5 14 10 -3 6 -15 10 -26 10
 -11 0 -17 -4 -14 -10z"
      />
      <path
        d="M1330 631 c0 -32 6 -55 16 -65 17 -18 50 -21 59 -6 3 6 -1 10 -9 10
 -13 0 -16 12 -16 55 0 52 -1 55 -25 55 -23 0 -25 -3 -25 -49z"
      />
      <path
        d="M1422 618 c3 -57 5 -63 26 -66 21 -3 22 0 22 62 0 64 -1 66 -25 66
 -25 0 -26 -1 -23 -62z"
      />
      <path
        d="M1600 626 c0 -66 17 -85 61 -69 16 6 29 7 29 2 0 -5 10 -9 23 -9 21
 0 22 4 20 62 -1 59 -3 63 -25 66 -22 3 -24 0 -20 -27 6 -42 -5 -81 -23 -81
 -11 0 -15 13 -15 55 0 52 -1 55 -25 55 -24 0 -25 -3 -25 -54z"
      />
      <path
        d="M1770 615 c0 -63 1 -65 25 -65 24 0 25 2 25 65 0 63 -1 65 -25 65
 -24 0 -25 -2 -25 -65z"
      />
      <path
        d="M1842 658 c2 -12 10 -23 18 -23 22 0 19 39 -3 43 -15 3 -18 -1 -15
 -20z"
      />
      <path
        d="M1907 662 c-25 -27 -22 -78 5 -96 12 -9 32 -15 43 -15 17 1 17 2 3 6
 -15 4 -18 16 -18 64 0 62 -7 70 -33 41z"
      />
      <path
        d="M1960 650 c0 -25 4 -30 25 -30 30 0 33 20 7 43 -26 24 -32 21 -32
 -13z"
      />
      <path
        d="M2090 666 c-8 -10 -10 -20 -4 -26 14 -14 32 3 25 23 -6 17 -8 18 -21
 3z"
      />
      <path
        d="M2140 621 c0 -44 4 -60 16 -65 29 -11 34 -6 34 40 0 51 -14 84 -35
 84 -12 0 -15 -14 -15 -59z"
      />
      <path
        d="M2226 643 c9 -21 20 -48 25 -60 21 -55 45 -2 26 59 -10 32 -16 38
 -40 38 l-27 0 16 -37z"
      />
      <path
        d="M2306 643 c9 -21 20 -48 25 -60 21 -55 45 -2 26 59 -10 32 -16 38
 -40 38 l-27 0 16 -37z"
      />
      <path
        d="M2385 670 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
 -4 -4 -10z"
      />
      <path
        d="M2431 666 c-9 -10 -8 -16 4 -26 17 -14 17 -14 20 18 3 25 -7 29 -24
 8z"
      />
      <path
        d="M2487 628 c4 -68 9 -80 30 -76 14 3 17 12 14 53 -3 51 -14 75 -35 75
 -8 0 -11 -18 -9 -52z"
      />
      <path
        d="M2568 615 c3 -61 6 -66 25 -63 18 3 21 10 21 63 1 57 0 60 -24 63
 -25 3 -25 2 -22 -63z"
      />
      <path
        d="M2632 658 c2 -13 10 -23 18 -23 8 0 16 10 18 23 3 17 -2 22 -18 22
 -16 0 -21 -5 -18 -22z"
      />
      <path
        d="M2696 658 c-9 -12 -16 -33 -16 -45 0 -27 33 -63 57 -63 13 0 14 3 5
 12 -19 19 -15 95 6 107 15 9 13 10 -10 11 -17 0 -33 -8 -42 -22z"
      />
      <path
        d="M2915 670 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
 -4 -4 -10z"
      />
      <path
        d="M2855 658 c-12 -31 -1 -52 33 -60 18 -5 32 -15 32 -24 0 -8 5 -12 10
 -9 14 9 13 48 -2 63 -7 7 -20 12 -30 12 -9 0 -21 8 -27 18 -9 16 -10 16 -16 0z"
      />
      <path
        d="M280 606 c0 -78 106 -103 140 -33 11 22 11 22 -7 -1 -16 -19 -27 -23
 -63 -20 -59 4 -66 28 -8 29 l43 2 -35 7 -35 7 35 2 c44 2 80 11 80 21 0 4 -19
 4 -42 -1 -31 -5 -49 -4 -65 7 -34 21 -43 17 -43 -20z"
      />
      <path
        d="M851 613 c5 -15 7 -38 4 -52 -5 -18 3 -44 26 -87 l32 -62 -22 -27
 c-16 -21 -21 -42 -21 -86 0 -32 4 -60 9 -63 13 -8 91 83 91 105 0 10 -5 30
 -12 44 -12 27 -5 48 35 108 14 21 18 39 14 67 -3 21 -2 41 1 45 3 3 7 12 8 20
 2 12 -14 15 -87 15 l-89 0 11 -27z m67 -23 c15 -1 15 -2 0 -11 -11 -6 -18 -22
 -18 -40 0 -17 4 -28 9 -25 5 3 11 -3 14 -13 4 -15 1 -18 -12 -14 -32 12 -41
 26 -41 70 0 37 3 44 16 39 9 -3 23 -6 32 -6z m76 -21 c7 -34 -6 -64 -33 -78
 -16 -9 -18 -5 -17 42 1 36 6 54 16 59 25 11 27 9 34 -23z"
      />
      <path
        d="M2102 620 c-28 -12 -38 -36 -22 -55 25 -30 45 -18 45 25 0 22 0 40 0
 39 0 0 -10 -4 -23 -9z"
      />
      <path
        d="M2444 620 c-29 -11 -37 -36 -18 -55 26 -26 39 -18 39 25 0 22 0 40 0
 39 0 0 -9 -4 -21 -9z"
      />
      <path
        d="M2850 575 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
 -4 -7 -4 -15z"
      />
      <path
        d="M471 570 c-2 -3 -4 -15 -7 -28 -4 -25 31 -68 42 -51 3 6 -1 16 -9 22
 -9 7 -18 23 -20 37 -2 14 -5 23 -6 20z"
      />
      <path
        d="M207 533 c-9 -15 10 -102 28 -130 l19 -28 8 31 c4 16 19 41 32 53
 l25 23 -21 29 c-16 22 -30 29 -54 29 -18 0 -35 -3 -37 -7z"
      />
      <path
        d="M70 516 c0 -30 13 -76 22 -76 9 0 38 60 38 80 0 5 -13 10 -30 10 -19
 0 -30 -5 -30 -14z"
      />
      <path
        d="M1406 514 c-9 -8 -16 -25 -17 -37 -6 -146 -6 -147 21 -147 l25 0 0
 100 c0 55 -3 100 -7 100 -4 0 -14 -7 -22 -16z"
      />
      <path d="M1446 514 c-8 -22 -8 -24 8 -24 21 0 28 16 12 29 -11 9 -15 8 -20 -5z" />
      <path
        d="M1604 505 c-8 -19 12 -36 33 -28 19 7 12 37 -10 41 -9 2 -20 -4 -23
 -13z"
      />
      <path d="M748 457 c-3 -15 -2 -27 3 -27 13 0 17 14 9 35 -6 17 -7 16 -12 -8z" />
      <path
        d="M1250 446 c-10 -13 -10 -20 -2 -28 16 -16 32 2 23 25 -6 17 -8 18
 -21 3z"
      />
      <path
        d="M1300 398 c4 -56 8 -63 28 -66 20 -3 22 0 22 47 0 32 -6 55 -16 65
 -31 31 -39 19 -34 -46z"
      />
      <path
        d="M1475 395 c0 -63 1 -65 25 -65 24 0 25 3 25 63 0 59 -1 62 -25 65
 -24 3 -25 1 -25 -63z"
      />
      <path
        d="M1543 444 c-8 -21 13 -42 28 -27 13 13 5 43 -11 43 -6 0 -13 -7 -17
 -16z"
      />
      <path
        d="M1600 395 c0 -63 1 -65 25 -65 24 0 25 2 25 65 0 63 -1 65 -25 65
 -24 0 -25 -2 -25 -65z"
      />
      <path
        d="M1700 440 c-43 -43 -12 -111 50 -109 25 0 25 0 3 9 -19 8 -23 17 -23
 53 0 24 5 48 12 55 9 9 8 12 -5 12 -9 0 -26 -9 -37 -20z"
      />
      <path
        d="M1766 444 c-9 -23 10 -42 26 -26 10 10 9 16 -4 28 -14 14 -16 14 -22
 -2z"
      />
      <path
        d="M1843 453 c-18 -7 -16 -43 2 -43 9 0 15 9 15 25 0 14 -1 25 -2 24 -2
 0 -9 -3 -15 -6z"
      />
      <path
        d="M1890 398 c4 -55 8 -63 26 -66 20 -3 21 1 16 50 -5 54 -16 78 -36 78
 -7 0 -9 -20 -6 -62z"
      />
      <path
        d="M440 442 c0 -8 59 -36 65 -31 1 2 -12 12 -31 21 -19 10 -34 14 -34
 10z"
      />
      <path
        d="M723 399 c-13 -4 -23 -11 -23 -14 0 -4 5 -3 10 0 12 7 12 -22 0 -50
 -8 -19 -8 -19 -18 5 -10 24 -11 24 -11 3 -1 -13 8 -28 19 -35 23 -14 26 -49 8
 -78 -10 -16 -9 -23 12 -45 16 -17 33 -25 50 -23 33 4 40 42 10 58 -25 14 -24
 57 1 52 21 -3 30 20 22 58 -6 35 -37 41 -60 13 -9 -12 -9 -7 2 16 19 38 10 53
 -22 40z"
      />
      <path
        d="M388 388 c16 -16 15 -45 0 -51 -9 -4 -8 -6 2 -6 9 -1 21 12 27 28 9
 24 8 31 -4 35 -26 10 -38 7 -25 -6z"
      />
      <path
        d="M1239 384 c-16 -19 -1 -48 28 -52 16 -2 19 2 15 33 -4 37 -21 45 -43
 19z"
      />
      <path
        d="M1832 391 c-21 -13 -11 -55 14 -59 18 -3 20 2 20 33 -1 35 -10 42
 -34 26z"
      />
      <path d="M299 378 c-7 -25 -7 -48 1 -48 6 0 10 11 10 25 0 20 -7 35 -11 23z" />
      <path
        d="M610 216 c0 -41 5 -78 10 -81 6 -4 10 23 10 74 0 47 -4 81 -10 81 -6
 0 -10 -31 -10 -74z"
      />
      <path
        d="M490 180 c0 -5 16 -10 35 -10 19 0 35 5 35 10 0 6 -16 10 -35 10 -19
 0 -35 -4 -35 -10z"
      />
      <path
        d="M460 138 c0 -4 7 -8 15 -8 8 0 15 4 15 8 0 5 -7 9 -15 9 -8 0 -15 -4
 -15 -9z"
      />
    </g>
  </svg>
);
export const MitIcon = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="766.000000pt"
    height="383.000000pt"
    viewBox="0 0 766.000000 383.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,383.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M1612 3623 c50 -115 119 -273 153 -353 218 -504 385 -884 394 -893 4
-4 27 23 51 60 43 66 189 289 395 603 56 85 166 254 245 375 79 121 168 258
199 305 31 46 60 90 64 97 6 11 -143 13 -792 13 l-799 0 90 -207z"
      />
      <path
        d="M4496 3563 c-3 -16 -17 -111 -31 -213 -14 -102 -28 -197 -31 -212 -5
-25 -3 -28 19 -28 24 0 26 4 37 88 6 48 17 123 24 167 l12 80 84 -167 c47 -93
88 -168 92 -168 4 0 46 75 92 168 96 192 84 195 114 -33 16 -121 19 -130 40
-133 16 -2 22 2 22 15 0 35 -64 463 -70 462 -3 0 -48 -89 -101 -197 l-97 -197
-96 198 c-53 108 -98 197 -101 197 -2 0 -6 -12 -9 -27z"
      />
      <path d="M5060 3350 l0 -240 25 0 25 0 0 240 0 240 -25 0 -25 0 0 -240z" />
      <path
        d="M5170 3565 c0 -24 3 -25 55 -25 l55 0 0 -215 c0 -208 1 -215 20 -215
19 0 20 7 20 215 l0 215 55 0 c52 0 55 1 55 25 l0 25 -130 0 -130 0 0 -25z"
      />
      <path d="M5670 3350 l0 -240 25 0 25 0 0 240 0 240 -25 0 -25 0 0 -240z" />
      <path
        d="M5830 3351 l0 -241 123 0 c98 0 130 4 164 19 106 49 153 214 93 331
-48 94 -105 122 -262 128 l-118 4 0 -241z m257 166 c95 -50 127 -171 73 -278
-29 -56 -83 -81 -192 -87 l-88 -5 0 198 0 198 88 -5 c52 -3 100 -12 119 -21z"
      />
      <path
        d="M6330 3350 l0 -240 135 0 c128 0 135 1 135 20 0 19 -7 20 -110 20
l-110 0 0 98 0 97 110 -3 110 -3 0 25 0 26 -110 0 -110 0 0 75 0 75 110 0 110
0 0 25 0 25 -135 0 -135 0 0 -240z"
      />
      <path
        d="M1185 3360 c-192 -93 -376 -182 -407 -197 l-57 -28 355 -425 c195
-234 358 -426 362 -427 4 -1 34 33 67 75 32 42 113 146 180 230 66 85 132 170
148 190 l27 37 -93 220 c-52 121 -120 282 -152 358 -32 75 -63 137 -69 136 -6
0 -168 -77 -361 -169z"
      />
      <path
        d="M4315 2896 c-91 -42 -138 -119 -138 -226 0 -36 7 -81 15 -100 48
-112 177 -171 306 -140 48 11 132 62 132 80 0 5 -12 23 -26 40 -27 31 -27 31
-48 12 -61 -56 -144 -67 -211 -29 -96 54 -102 213 -11 272 61 40 162 33 213
-15 12 -11 24 -20 27 -20 2 0 18 13 34 29 l31 28 -27 26 c-72 69 -202 88 -297
43z"
      />
      <path
        d="M5445 2909 c-30 -15 -65 -71 -65 -105 0 -38 26 -79 85 -134 117 -108
120 -113 89 -144 -25 -25 -63 -19 -94 14 l-28 30 -36 -21 c-20 -11 -36 -25
-36 -29 0 -18 56 -73 87 -86 101 -43 213 24 213 126 0 48 -21 79 -109 159 -45
40 -81 76 -81 81 0 11 29 40 39 40 5 0 25 -11 45 -25 l36 -25 33 30 32 30 -30
26 c-16 14 -40 30 -53 35 -30 12 -101 11 -127 -2z"
      />
      <path d="M3540 2670 l0 -240 45 0 45 0 0 240 0 240 -45 0 -45 0 0 -240z" />
      <path
        d="M3730 2670 l0 -240 45 0 45 0 0 157 0 156 102 -156 102 -157 43 0 43
0 0 240 0 240 -45 0 -44 0 -3 -152 -3 -153 -99 153 -100 152 -43 0 -43 0 0
-240z"
      />
      <path
        d="M4702 2673 l3 -238 120 0 120 0 3 43 3 42 -80 0 -81 0 0 195 0 195
-45 0 -45 0 2 -237z"
      />
      <path
        d="M4990 2728 c0 -160 3 -188 20 -226 46 -102 213 -110 277 -13 22 32
23 43 23 227 l0 194 -45 0 -45 0 0 -180 c0 -167 -1 -181 -20 -200 -11 -11 -33
-20 -50 -20 -17 0 -39 9 -50 20 -19 19 -20 33 -20 200 l0 180 -45 0 -45 0 0
-182z"
      />
      <path d="M5722 2673 l3 -238 45 0 45 0 3 238 2 237 -50 0 -50 0 2 -237z" />
      <path
        d="M5870 2900 c0 -5 31 -96 69 -202 37 -106 74 -210 81 -231 12 -37 13
-38 57 -35 l46 3 77 215 c106 294 101 262 45 258 l-47 -3 -54 -150 c-30 -82
-57 -157 -60 -165 -3 -8 -26 41 -50 110 -82 231 -69 210 -120 210 -24 0 -44
-4 -44 -10z"
      />
      <path
        d="M6340 2670 l0 -240 130 0 130 0 0 45 0 44 -82 3 -83 3 0 60 0 60 83
3 82 3 0 44 0 45 -85 0 -85 0 0 40 0 40 85 0 85 0 0 45 0 45 -130 0 -130 0 0
-240z"
      />
      <path
        d="M3997 2286 c-55 -21 -103 -61 -134 -114 -24 -40 -28 -58 -28 -122 0
-109 45 -184 137 -231 47 -24 153 -26 206 -3 185 77 200 348 25 451 -54 31
-149 40 -206 19z m154 -96 c74 -38 105 -126 71 -202 -25 -56 -58 -85 -107 -96
-147 -31 -250 136 -158 256 47 62 122 78 194 42z"
      />
      <path
        d="M5827 2286 c-218 -78 -238 -364 -32 -468 53 -27 155 -28 209 -3 94
45 153 146 144 249 -14 161 -176 273 -321 222z m143 -98 c119 -60 114 -236 -8
-290 -50 -22 -97 -18 -147 12 -101 63 -90 231 19 281 54 24 82 24 136 -3z"
      />
      <path
        d="M2707 2283 c-4 -3 -7 -111 -7 -240 l0 -233 45 0 45 0 0 240 0 240
-38 0 c-21 0 -42 -3 -45 -7z"
      />
      <path
        d="M2897 2283 c-4 -3 -7 -111 -7 -240 l0 -233 50 0 49 0 3 149 3 149 95
-148 95 -149 48 -1 47 0 0 240 0 240 -45 0 -44 0 -3 -157 -3 -157 -102 157
-103 157 -38 0 c-21 0 -42 -3 -45 -7z"
      />
      <path
        d="M3387 2283 c-4 -3 -7 -111 -7 -240 l0 -233 50 0 50 0 0 152 0 152 91
-139 c50 -77 94 -145 96 -152 3 -8 24 -13 54 -13 l49 0 -2 238 -3 237 -42 3
-42 3 -3 -158 -3 -158 -103 158 -102 157 -38 0 c-21 0 -42 -3 -45 -7z"
      />
      <path
        d="M4340 2273 c1 -10 36 -117 79 -238 l78 -220 45 -3 c36 -2 47 1 53 15
15 39 165 456 165 460 0 2 -21 3 -47 1 l-47 -3 -31 -85 c-17 -47 -44 -121 -60
-165 l-28 -79 -17 39 c-9 22 -36 97 -61 167 l-44 128 -42 0 c-35 0 -43 -3 -43
-17z"
      />
      <path
        d="M4797 2068 c-47 -123 -89 -231 -93 -240 -5 -16 0 -18 43 -18 l49 0
18 50 18 50 97 0 97 0 18 -50 18 -50 49 0 48 0 -24 65 c-14 36 -40 104 -59
152 -18 49 -48 127 -67 176 l-32 87 -47 0 -46 0 -87 -222z m167 3 c14 -36 26
-66 26 -68 0 -2 -27 -3 -61 -3 -33 0 -59 3 -57 8 2 4 14 37 28 74 13 37 28 64
31 60 4 -4 19 -36 33 -71z"
      />
      <path
        d="M5160 2245 l0 -45 40 0 40 0 0 -195 0 -195 50 0 50 0 0 195 0 195 40
0 40 0 0 45 0 45 -130 0 -130 0 0 -45z"
      />
      <path d="M5500 2050 l0 -240 45 0 45 0 0 240 0 240 -45 0 -45 0 0 -240z" />
      <path
        d="M6220 2050 l0 -240 45 0 44 0 3 152 3 153 99 -153 99 -152 44 0 43 0
0 240 0 240 -45 0 -44 0 -3 -152 -3 -153 -90 138 c-49 77 -96 145 -103 153 -7
8 -31 14 -53 14 l-39 0 0 -240z"
      />
      <path
        d="M3055 1650 c-46 -20 -99 -70 -123 -114 -24 -45 -23 -179 2 -228 45
-92 117 -133 231 -133 85 0 114 10 174 61 l32 27 -32 33 -31 33 -27 -25 c-35
-33 -84 -47 -138 -41 -136 15 -190 179 -92 275 60 58 144 61 224 6 l38 -26 31
32 31 31 -30 25 c-16 14 -48 34 -70 45 -53 25 -164 25 -220 -1z"
      />
      <path
        d="M5915 1648 c-56 -28 -83 -56 -110 -108 -43 -85 -38 -178 15 -260 55
-85 180 -129 284 -100 89 25 166 122 166 210 l0 40 -120 0 -120 0 0 -45 0 -45
71 0 70 0 -20 -29 c-28 -39 -71 -55 -132 -49 -56 6 -92 28 -127 79 -31 44 -28
129 6 176 49 69 173 85 245 31 l34 -27 32 33 33 34 -34 26 c-56 42 -101 56
-180 56 -54 -1 -84 -6 -113 -22z"
      />
      <path
        d="M3440 1420 l0 -240 45 0 45 0 0 105 0 105 80 0 80 0 0 -105 0 -105
45 0 45 0 0 240 0 240 -45 0 -45 0 0 -90 0 -90 -80 0 -80 0 0 90 0 90 -45 0
-45 0 0 -240z"
      />
      <path
        d="M4011 1638 c-82 -207 -171 -442 -171 -450 0 -5 21 -8 46 -6 45 3 47
4 63 48 l17 45 100 3 100 3 18 -51 c18 -50 18 -50 63 -50 37 0 44 3 41 18 -2
9 -41 117 -88 240 l-85 222 -48 0 c-40 0 -49 -4 -56 -22z m100 -220 l19 -48
-60 0 c-33 0 -60 3 -60 8 0 4 12 40 27 81 l27 75 14 -35 c8 -19 23 -55 33 -81z"
      />
      <path
        d="M4350 1420 l0 -241 123 3 122 3 3 43 3 42 -80 0 -81 0 0 195 0 195
-45 0 -45 0 0 -240z"
      />
      <path
        d="M4660 1420 l0 -241 123 3 122 3 3 43 3 42 -80 0 -81 0 0 195 0 195
-45 0 -45 0 0 -240z"
      />
      <path
        d="M4980 1420 l0 -240 130 0 130 0 0 45 0 45 -85 0 -85 0 0 65 0 65 85
0 85 0 0 45 0 45 -85 0 -85 0 0 40 0 40 85 0 85 0 0 45 0 45 -130 0 -130 0 0
-240z"
      />
      <path
        d="M5330 1420 l0 -240 45 0 44 0 3 154 3 154 99 -154 100 -154 43 0 43
0 0 240 0 240 -45 0 -45 0 0 -157 0 -156 -101 156 -101 157 -44 0 -44 0 0
-240z"
      />
      <path
        d="M6340 1420 l0 -240 130 0 130 0 0 45 0 44 -82 3 -83 3 0 60 0 60 83
3 82 3 0 44 0 45 -85 0 -85 0 0 40 0 40 85 0 85 0 0 45 0 45 -130 0 -130 0 0
-240z"
      />
      <path
        d="M1393 703 l-150 -308 26 -7 c26 -7 1773 -325 1841 -335 35 -5 -38 40
-825 517 -143 86 -365 221 -494 299 -128 77 -237 141 -241 141 -3 0 -74 -138
-157 -307z"
      />
      <path
        d="M4426 833 c-3 -4 -6 -60 -6 -125 0 -111 1 -118 20 -118 17 0 20 7 20
40 0 39 1 40 33 40 26 -1 37 -8 59 -40 17 -24 36 -40 48 -40 26 0 25 6 -5 46
-14 18 -25 36 -25 39 0 4 11 16 25 27 52 41 21 127 -47 129 -18 1 -52 3 -75 4
-22 2 -44 1 -47 -2z m135 -43 c10 -6 19 -19 19 -30 0 -31 -28 -50 -76 -50
l-44 0 0 38 c0 21 3 42 7 45 10 11 72 8 94 -3z"
      />
      <path
        d="M4880 821 c0 -14 5 -18 20 -14 11 3 20 12 20 19 0 8 -9 14 -20 14
-13 0 -20 -7 -20 -19z"
      />
      <path
        d="M6208 828 c-2 -7 -4 -62 -3 -123 0 -103 1 -110 20 -110 16 0 20 7 21
35 2 96 3 99 29 106 41 10 55 -10 55 -82 0 -57 2 -64 20 -64 18 0 20 7 20 75
0 63 -3 77 -22 95 -23 21 -54 26 -78 10 -18 -11 -30 5 -30 43 0 27 -24 39 -32
15z"
      />
      <path
        d="M5834 800 c-4 -16 -10 -30 -15 -30 -5 0 -9 -7 -9 -15 0 -8 5 -15 10
-15 6 0 10 -25 10 -56 0 -73 12 -94 54 -94 18 0 35 3 39 6 10 11 -4 33 -19 27
-17 -6 -27 17 -26 60 0 54 1 57 20 57 24 0 32 8 25 26 -3 8 -16 14 -30 14 -13
0 -22 4 -19 9 9 14 -4 41 -20 41 -8 0 -17 -13 -20 -30z"
      />
      <path
        d="M6076 823 c-3 -4 -6 -15 -6 -25 0 -10 -4 -18 -10 -18 -5 0 -10 -9
-10 -20 0 -11 5 -20 10 -20 6 0 10 -26 10 -59 0 -82 5 -91 51 -91 32 0 39 3
39 20 0 15 -6 19 -22 17 -21 -2 -23 3 -26 56 -3 55 -2 57 23 57 31 0 34 27 3
32 -15 2 -24 11 -26 25 -3 21 -25 37 -36 26z"
      />
      <path
        d="M4697 762 c-51 -31 -56 -116 -9 -152 31 -25 104 -27 122 -5 18 21 -3
46 -22 27 -26 -26 -88 -8 -88 25 0 9 18 13 65 13 58 0 65 2 65 20 0 32 -21 67
-47 79 -33 15 -53 14 -86 -7z m81 -34 c25 -25 13 -38 -33 -38 -30 0 -45 4 -45
13 0 19 21 37 45 37 12 0 26 -5 33 -12z"
      />
      <path
        d="M4886 773 c-3 -4 -6 -46 -6 -95 0 -81 2 -88 20 -88 19 0 20 7 20 89
0 67 -3 90 -14 94 -8 3 -17 3 -20 0z"
      />
      <path
        d="M4993 773 c-9 -3 -13 -32 -13 -94 0 -82 1 -89 20 -89 18 0 20 7 20
64 0 70 12 90 52 84 20 -3 23 -9 26 -53 3 -71 10 -95 27 -95 16 0 18 11 17
100 -1 44 -5 58 -23 72 -26 22 -49 23 -74 4 -16 -11 -21 -11 -30 -1 -5 7 -16
11 -22 8z"
      />
      <path
        d="M5180 769 c0 -6 16 -49 36 -95 48 -112 63 -111 110 5 25 63 31 87 22
92 -19 12 -32 -4 -52 -65 -11 -31 -22 -56 -26 -56 -4 0 -16 25 -26 56 -13 40
-26 59 -42 65 -14 5 -22 5 -22 -2z"
      />
      <path
        d="M5431 766 c-54 -30 -66 -97 -25 -145 21 -26 33 -31 68 -31 50 0 90
24 66 39 -9 7 -18 7 -24 1 -14 -14 -60 -12 -74 2 -28 28 -13 38 53 38 63 0 65
1 65 26 0 32 -50 84 -82 84 -13 -1 -34 -7 -47 -14z m79 -45 c15 -30 14 -31
-35 -31 -45 0 -50 5 -39 34 9 23 61 21 74 -3z"
      />
      <path
        d="M5613 767 c-5 -6 -11 -49 -12 -94 -3 -83 -3 -83 23 -83 24 0 25 3 28
66 3 74 21 99 56 78 13 -8 18 -27 20 -78 3 -58 5 -66 22 -66 18 0 20 7 20 75
0 62 -4 79 -20 95 -21 21 -55 26 -79 11 -9 -6 -22 -6 -32 -1 -11 7 -20 5 -26
-3z"
      />
      <path
        d="M6457 762 c-46 -28 -55 -106 -17 -147 36 -38 140 -33 140 8 0 4 -20
5 -45 1 -47 -7 -75 5 -75 32 0 11 16 14 65 14 63 0 65 1 65 26 0 32 -50 84
-82 84 -13 0 -36 -8 -51 -18z m81 -34 c25 -25 13 -38 -33 -38 -30 0 -45 4 -45
13 0 19 21 37 45 37 12 0 26 -5 33 -12z"
      />
      <path
        d="M5496 434 c-9 -8 -16 -24 -16 -34 0 -10 -6 -20 -12 -23 -10 -3 -10
-9 -1 -28 7 -13 14 -53 15 -89 2 -50 6 -65 18 -65 12 0 16 16 18 72 3 65 5 72
25 75 12 2 23 11 25 21 3 13 -3 17 -23 17 -21 0 -26 4 -21 16 3 9 6 18 6 20 0
2 9 4 20 4 11 0 20 7 20 15 0 20 -54 20 -74 -1z"
      />
      <path
        d="M6430 325 c0 -118 1 -125 20 -125 14 0 20 7 20 24 0 20 26 56 33 45
41 -60 59 -77 77 -72 19 5 18 8 -16 55 l-36 50 38 39 c37 38 38 39 13 39 -16
0 -38 -13 -59 -35 -19 -19 -38 -35 -42 -35 -4 0 -8 32 -8 70 0 63 -2 70 -20
70 -19 0 -20 -7 -20 -125z"
      />
      <path
        d="M4000 314 c0 -114 2 -125 18 -122 13 2 18 16 22 53 5 54 2 51 80 54
28 1 40 5 40 16 0 12 -13 15 -60 15 l-60 0 0 35 0 35 70 0 c63 0 70 2 70 20 0
19 -7 20 -90 20 l-90 0 0 -126z"
      />
      <path
        d="M5683 428 c2 -7 22 -64 43 -126 33 -95 42 -112 58 -110 14 2 26 23
45 80 14 42 29 80 33 83 3 4 19 -32 34 -80 24 -72 32 -85 48 -83 15 2 28 28
58 118 21 63 38 118 38 122 0 4 -8 8 -19 8 -14 0 -24 -19 -45 -86 -15 -47 -31
-83 -34 -79 -4 3 -19 41 -33 83 -19 58 -30 78 -45 80 -17 2 -24 -11 -49 -88
-15 -51 -31 -86 -35 -80 -4 7 -18 48 -31 91 -21 70 -26 79 -47 79 -15 0 -22
-5 -19 -12z"
      />
      <path
        d="M4449 421 c-1 -6 -2 -16 -3 -21 0 -6 -8 -15 -16 -20 -13 -8 -13 -13
-2 -31 8 -12 16 -47 19 -78 6 -66 17 -83 52 -79 32 4 43 38 12 38 -22 0 -24 4
-23 55 0 51 1 55 22 55 13 0 20 7 20 20 0 13 -7 20 -20 20 -11 0 -21 5 -21 10
-1 6 -2 16 -3 22 -1 16 -36 23 -37 9z"
      />
      <path
        d="M4210 318 c0 -82 7 -103 36 -119 20 -10 32 -10 56 -1 22 8 35 8 44 1
25 -21 34 2 34 92 0 82 -1 89 -20 89 -18 0 -20 -7 -20 -63 0 -68 -10 -87 -46
-87 -34 0 -35 5 -43 138 -1 6 -10 12 -21 12 -18 0 -20 -7 -20 -62z"
      />
      <path
        d="M4580 305 c0 -62 4 -79 20 -95 21 -21 55 -26 79 -11 9 6 21 5 33 -2
28 -18 37 5 35 97 -2 75 -4 81 -24 84 -21 3 -22 -1 -25 -70 -3 -72 -3 -73 -32
-76 -38 -5 -46 10 -46 86 0 55 -2 62 -20 62 -18 0 -20 -7 -20 -75z"
      />
      <path
        d="M4800 284 c0 -86 2 -95 18 -92 13 2 18 16 22 55 5 52 30 93 57 93 7
0 13 9 13 20 0 25 -26 26 -52 3 -17 -15 -18 -15 -18 0 0 10 -8 17 -20 17 -19
0 -20 -7 -20 -96z"
      />
      <path
        d="M4969 367 c-9 -7 -21 -22 -27 -34 -47 -87 56 -183 137 -127 31 22 13
37 -27 23 -26 -9 -37 -8 -57 5 -41 27 -29 36 46 36 l72 0 -7 32 c-9 48 -43 78
-85 78 -20 0 -43 -6 -52 -13z m89 -44 c14 -23 14 -23 -37 -23 -54 0 -62 8 -35
35 22 21 53 16 72 -12z"
      />
      <path
        d="M5277 369 c-9 -5 -24 -24 -33 -41 -23 -45 -11 -94 29 -118 39 -24 68
-25 108 -5 56 29 63 115 12 155 -28 22 -86 26 -116 9z m87 -40 c38 -30 34 -74
-9 -96 -25 -13 -60 -1 -75 27 -20 37 5 80 51 89 4 0 18 -8 33 -20z"
      />
      <path
        d="M6075 356 c-33 -33 -39 -66 -21 -110 39 -93 186 -63 186 39 0 82
-108 128 -165 71z m105 -28 c39 -42 16 -98 -40 -98 -29 0 -60 30 -60 58 0 18
46 62 64 62 8 0 24 -10 36 -22z"
      />
      <path
        d="M6289 373 c-5 -32 -6 -151 -2 -165 5 -20 32 -24 35 -5 2 20 5 50 7
80 1 20 10 33 31 45 16 9 30 25 30 35 0 21 -23 22 -40 2 -15 -18 -31 -20 -27
-3 1 6 -6 14 -15 16 -10 2 -19 0 -19 -5z"
      />
    </g>
  </svg>
);
export const PitchIcon = () => (
  <svg
    version="1.0"
    width="296.000000pt"
    height="341.000000pt"
    viewBox="0 0 296.000000 341.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,341.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M0 1930 l0 -1480 545 0 545 0 2 -224 3 -224 192 80 193 79 192 -79
193 -80 3 224 2 224 545 0 545 0 0 1480 0 1480 -1480 0 -1480 0 0 -1480z
m1795 1300 c-3 -5 -15 -10 -26 -10 -10 0 -19 5 -19 10 0 6 12 10 26 10 14 0
23 -4 19 -10z m-15 -50 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10
10 6 0 10 -4 10 -10z m13 -47 c8 -10 18 -30 22 -45 4 -15 13 -29 21 -32 8 -3
14 -12 14 -21 0 -8 7 -15 15 -15 11 0 15 12 15 48 0 26 5 53 12 60 16 16 48
15 49 0 0 -10 2 -10 6 0 7 18 33 15 33 -5 0 -14 2 -15 9 -4 24 38 31 -6 31
-190 l0 -189 25 0 c14 0 25 -6 26 -12 0 -10 2 -10 6 0 6 15 45 16 61 0 9 -9
12 -9 12 0 0 7 11 12 25 12 14 0 25 -5 25 -12 0 -9 3 -9 12 0 16 16 58 15 59
0 0 -10 2 -10 6 0 2 6 15 12 28 12 13 0 26 -6 29 -12 5 -10 7 -10 12 0 3 6 17
12 30 12 13 0 24 -6 25 -12 0 -10 2 -10 6 0 2 6 13 12 24 12 16 0 19 8 19 58
0 31 3 68 7 81 6 23 7 23 14 5 7 -19 8 -19 9 1 l1 20 9 -20 9 -20 1 20 1 20 9
-20 9 -20 1 20 1 20 9 -20 c5 -11 9 -39 9 -62 l1 -43 100 0 100 0 0 40 c0 29
4 40 15 40 8 0 16 10 16 23 l2 22 4 -22 c2 -13 11 -23 19 -23 10 0 14 -12 14
-40 0 -29 4 -40 15 -40 13 0 15 -129 15 -1100 l0 -1100 -485 0 -485 0 0 395 0
395 -390 0 -390 0 0 -395 0 -395 -485 0 -485 0 0 1105 0 1105 30 0 c17 0 30 5
30 10 0 6 14 10 30 10 21 0 30 -5 31 -17 1 -17 2 -17 6 0 6 23 83 25 83 2 0
-8 7 -15 16 -15 12 0 15 10 13 43 -2 51 9 86 22 65 7 -10 9 -10 9 2 0 13 1 13
10 0 6 -10 10 -11 10 -2 0 17 28 15 46 -3 10 -9 13 -23 9 -36 -4 -11 -4 -30
-1 -42 5 -21 10 -22 130 -21 68 1 130 5 136 9 8 5 10 21 7 42 -4 24 -1 40 8
50 12 11 15 12 16 1 0 -10 2 -10 6 1 5 11 7 11 14 0 7 -11 9 -11 9 -1 0 11 2
11 13 0 7 -7 12 -31 12 -53 0 -30 4 -40 18 -43 15 -3 17 5 17 60 0 75 11 98
34 79 9 -8 16 -22 16 -32 0 -11 5 -19 10 -19 6 0 10 6 10 13 0 8 4 7 10 -3 9
-13 10 -13 10 0 0 13 1 13 10 0 9 -13 10 -13 10 0 0 13 1 13 10 0 9 -13 10
-13 10 0 1 34 20 -16 20 -52 0 -20 4 -39 9 -42 5 -3 33 -8 62 -10 30 -3 61 -6
69 -7 54 -8 60 -2 60 62 0 52 2 60 18 57 13 -2 18 -15 20 -60 3 -49 6 -56 25
-60 12 -2 33 -1 47 2 21 5 25 12 26 46 1 21 2 45 3 52 1 7 15 12 36 12 37 0
38 -2 35 -62 -1 -27 4 -39 17 -47 30 -15 42 0 45 57 2 29 7 52 11 52 4 0 14 6
22 14 11 10 14 39 14 110 0 53 2 100 5 105 10 16 59 23 67 9 7 -10 9 -10 9 0
0 15 32 16 48 0 7 -7 12 -34 12 -60 0 -36 4 -48 15 -48 8 0 15 9 15 20 0 11 6
20 14 20 8 0 17 12 21 28 7 27 32 62 45 62 4 0 14 -8 23 -17z m-403 -1869 c0
-8 9 -14 20 -14 13 0 20 -7 20 -20 0 -22 -16 -27 -23 -7 -2 6 -7 9 -11 5 -9
-7 11 -48 22 -48 5 0 17 7 28 16 10 8 13 13 7 9 -9 -4 -13 3 -13 24 0 17 5 31
11 31 8 0 8 5 -1 15 -11 13 -7 15 30 15 37 0 41 -2 30 -15 -9 -10 -9 -15 -1
-15 6 0 11 -14 11 -31 0 -21 -4 -28 -12 -24 -7 4 -4 -1 6 -9 11 -9 23 -16 28
-16 11 0 31 41 22 48 -4 4 -9 1 -11 -5 -7 -20 -23 -15 -23 7 0 18 5 22 26 19
4 0 12 10 18 22 14 28 31 26 31 -3 0 -13 8 -26 19 -31 12 -5 16 -13 12 -25 -4
-10 1 -7 13 7 18 23 19 23 24 5 4 -16 5 -16 6 4 1 24 8 27 31 12 15 -9 15 -9
-43 -74 -9 -11 -16 -25 -15 -30 0 -6 -4 -24 -10 -39 -16 -39 -16 -39 23 -65
109 -75 154 -233 104 -367 -16 -43 -40 -75 -105 -140 -46 -47 -91 -85 -99 -85
-9 0 -15 -6 -14 -13 5 -40 -3 -106 -15 -123 -13 -16 -18 -17 -35 -6 -17 10
-25 10 -42 0 -17 -11 -22 -10 -35 6 -12 18 -19 73 -15 131 1 13 -11 27 -36 41
-21 12 -64 41 -95 64 -50 37 -60 51 -82 112 -55 148 -15 302 99 380 39 26 39
26 23 65 -6 15 -10 33 -10 39 1 5 -6 19 -15 30 -58 65 -58 65 -43 74 23 15 30
12 31 -12 1 -20 2 -20 6 -4 5 18 6 18 24 -5 13 -16 17 -18 13 -6 -5 13 -1 20
14 24 13 3 19 10 15 19 -3 8 -2 21 1 30 5 13 9 14 21 4 8 -7 15 -19 15 -26z
m100 -994 c0 -11 -4 -20 -10 -20 -5 0 -10 9 -10 20 0 11 5 20 10 20 6 0 10 -9
10 -20z"
      />
      <path
        d="M1740 3015 l-23 -25 23 -25 24 -25 28 27 28 27 -22 23 c-27 29 -29
29 -58 -2z"
      />
      <path d="M902 2830 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
      <path
        d="M1385 2553 c-42 -9 -100 -59 -127 -112 -63 -120 -20 -264 95 -323 80
-40 205 -21 260 40 30 33 2 35 -49 2 -39 -25 -59 -30 -106 -30 -68 0 -103 15
-146 64 -38 43 -56 106 -48 165 8 56 31 96 79 134 30 25 49 32 97 35 52 4 66
1 114 -27 55 -30 82 -28 54 6 -34 41 -140 63 -223 46z"
      />
      <path
        d="M2347 2547 c-96 -31 -151 -112 -152 -223 0 -61 4 -77 30 -119 41 -66
106 -100 190 -99 38 0 71 7 90 18 17 9 22 15 11 11 -79 -24 -107 -27 -157 -15
-219 53 -205 378 18 425 76 16 185 -45 212 -118 28 -72 3 -171 -45 -183 -49
-12 -63 21 -52 121 3 28 3 42 1 32 -4 -16 -7 -15 -24 6 -56 72 -169 13 -169
-87 0 -45 36 -86 75 -86 30 0 85 26 85 40 0 18 15 10 25 -12 16 -36 59 -35 95
1 27 26 30 36 30 92 0 49 -6 72 -25 105 -45 77 -153 118 -238 91z m125 -162
c16 -36 1 -90 -33 -119 -38 -33 -73 -33 -104 -1 -64 63 13 182 98 153 16 -6
33 -21 39 -33z"
      />
      <path
        d="M348 2408 c-5 -223 0 -308 17 -308 12 0 15 17 15 85 l0 85 79 0 c119
0 177 27 207 97 18 42 18 67 -2 109 -27 57 -74 74 -203 74 l-110 0 -3 -142z
m242 97 c16 -8 34 -24 40 -34 13 -26 13 -87 -1 -113 -19 -35 -86 -58 -171 -58
l-78 0 0 110 0 110 90 0 c62 0 100 -5 120 -15z"
      />
      <path
        d="M750 2325 c0 -218 1 -225 20 -225 19 0 20 7 20 225 0 218 -1 225 -20
225 -19 0 -20 -7 -20 -225z"
      />
      <path
        d="M870 2535 c0 -12 16 -15 80 -15 l80 0 0 -210 c0 -180 2 -210 15 -210
13 0 15 30 15 210 l0 210 80 0 c64 0 80 3 80 15 0 13 -26 15 -175 15 -149 0
-175 -2 -175 -15z"
      />
      <path
        d="M1702 2328 c3 -203 5 -223 21 -226 15 -3 17 7 17 102 l0 106 145 0
145 0 0 -105 c0 -87 3 -105 15 -105 13 0 15 32 15 225 0 193 -2 225 -15 225
-12 0 -15 -18 -15 -100 l0 -100 -145 0 -145 0 0 100 c0 94 -1 100 -20 100 -20
0 -20 -5 -18 -222z"
      />
      <path
        d="M350 1755 c0 -184 2 -215 15 -215 12 0 15 16 15 80 l0 80 85 0 c65 0
95 5 123 19 51 26 77 75 69 131 -11 86 -78 120 -232 120 l-75 0 0 -215z m194
175 c51 -11 76 -38 83 -87 5 -35 1 -45 -25 -74 -30 -34 -32 -34 -126 -37 l-96
-4 0 106 0 106 63 0 c34 0 80 -5 101 -10z"
      />
      <path
        d="M810 1950 c-12 -23 -155 -328 -176 -377 -13 -29 -12 -33 1 -33 9 0
27 25 43 58 l27 57 126 3 125 3 29 -61 c16 -33 35 -60 42 -60 7 0 13 4 13 8 0
23 -192 417 -204 420 -8 2 -20 -6 -26 -18z m79 -139 c28 -62 51 -115 51 -117
0 -2 -49 -4 -109 -4 l-110 0 36 78 c19 42 44 97 54 121 11 24 21 42 23 40 2
-2 26 -55 55 -118z"
      />
      <path
        d="M1107 1963 c-4 -3 -7 -100 -7 -215 l0 -208 146 0 c112 0 145 3 142
13 -3 8 -41 13 -131 15 l-127 3 0 199 c0 183 -4 213 -23 193z"
      />
      <path
        d="M1530 1763 c-52 -113 -96 -210 -98 -215 -2 -4 4 -8 12 -8 10 0 27 23
44 58 l27 57 126 3 126 3 27 -61 c15 -33 34 -60 42 -60 8 0 14 3 14 7 0 4 -43
100 -97 215 -67 144 -101 208 -112 208 -11 -1 -46 -66 -111 -207z m220 -70 c0
-1 -49 -3 -110 -3 l-109 0 30 68 c17 37 42 92 55 122 l25 54 54 -118 c30 -66
55 -121 55 -123z"
      />
      <path
        d="M1979 1947 c-24 -13 -57 -43 -74 -66 -26 -37 -30 -53 -33 -119 -3
-70 0 -82 27 -128 37 -63 108 -104 180 -104 70 0 194 65 162 84 -6 4 -29 -6
-52 -21 -36 -24 -53 -28 -109 -28 -58 0 -71 4 -104 29 -111 84 -96 268 26 332
55 29 187 6 213 -36 4 -6 11 -8 16 -5 21 14 6 35 -43 59 -69 34 -147 35 -209
3z"
      />
      <path
        d="M2310 1755 l0 -215 150 0 c127 0 150 2 150 15 0 13 -22 15 -135 15
l-135 0 0 85 0 85 120 0 c100 0 120 3 120 15 0 13 -20 15 -120 15 l-120 0 0
85 0 85 135 0 c113 0 135 2 135 15 0 13 -23 15 -150 15 l-150 0 0 -215z"
      />
      <path
        d="M1463 1255 c-16 -17 -17 -35 -3 -35 6 0 10 7 10 15 0 8 5 15 10 15 6
0 10 -7 10 -15 0 -8 5 -15 10 -15 15 0 12 19 -4 36 -17 17 -18 17 -33 -1z"
      />
      <path
        d="M1345 1210 c3 -5 -6 -12 -20 -16 -32 -8 -18 -27 16 -22 17 2 24 10
25 26 1 13 -5 22 -13 22 -8 0 -11 -4 -8 -10z"
      />
      <path
        d="M1594 1198 c1 -16 8 -24 25 -26 34 -5 48 14 16 22 -14 4 -23 11 -20
16 3 6 0 10 -8 10 -8 0 -14 -9 -13 -22z"
      />
      <path
        d="M1457 1188 c-13 -13 -26 -18 -42 -14 -13 3 -36 -1 -51 -9 -16 -8 -22
-15 -13 -15 8 0 20 5 25 10 8 8 19 8 38 0 15 -5 45 -10 66 -10 21 0 51 5 66
10 19 8 30 8 38 0 5 -5 17 -10 26 -10 8 0 2 7 -14 15 -15 8 -38 12 -51 9 -16
-4 -30 1 -44 15 -25 25 -21 25 -44 -1z m47 -13 c18 -14 17 -15 -24 -15 -41 0
-42 1 -24 15 10 8 21 14 24 14 3 0 14 -6 24 -14z"
      />
      <path d="M1388 1143 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
      <path d="M1548 1143 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
      <path d="M1330 1130 c-18 -12 -2 -12 25 0 13 6 15 9 5 9 -8 0 -22 -4 -30 -9z" />
      <path
        d="M1390 1128 c-44 -9 -78 -28 -51 -28 7 0 9 -4 6 -10 -3 -5 0 -10 7 -9
19 1 55 17 41 18 -22 1 -14 21 8 21 11 0 17 -4 14 -10 -4 -6 5 -10 21 -10 21
0 24 3 15 13 -6 8 -8 17 -4 20 8 8 1 8 -57 -5z"
      />
      <path
        d="M1512 1135 c4 -5 3 -14 -3 -22 -9 -10 -6 -13 15 -13 16 0 25 4 21 10
-3 6 3 10 14 10 22 0 30 -20 9 -21 -15 -1 21 -17 40 -18 7 -1 10 4 7 9 -3 6
-1 10 5 10 25 0 -3 18 -37 24 -21 4 -47 10 -58 13 -11 3 -17 2 -13 -2z"
      />
      <path d="M1605 1130 c27 -12 43 -12 25 0 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z" />
      <path d="M1468 1118 c9 -9 15 -9 24 0 9 9 7 12 -12 12 -19 0 -21 -3 -12 -12z" />
      <path
        d="M1435 1069 c16 -7 13 -8 -12 -4 -39 5 -65 -3 -56 -18 4 -6 0 -8 -11
-4 -9 4 -15 3 -12 -2 3 -5 -1 -12 -10 -15 -8 -3 -12 -2 -9 4 12 20 -6 9 -45
-27 -40 -35 -75 -84 -51 -69 7 5 9 1 5 -8 -3 -9 -9 -14 -14 -11 -13 8 -30 -44
-25 -77 4 -26 3 -29 -4 -13 -7 15 -10 3 -10 -45 0 -48 3 -60 10 -45 7 16 8 13
4 -13 -4 -31 16 -92 32 -92 3 0 21 9 40 21 24 15 32 26 28 39 -3 10 -2 21 3
24 6 3 9 -2 8 -11 0 -10 6 -18 16 -18 10 0 17 -4 17 -8 -1 -13 53 -67 67 -67
6 0 19 -12 29 -26 13 -21 19 -23 31 -13 11 9 18 9 26 1 8 -8 7 -13 -6 -18 -16
-6 -16 -8 0 -25 24 -26 34 -24 35 9 2 25 2 24 10 -8 6 -29 7 -25 5 23 -3 55 5
79 19 58 3 -6 12 -8 20 -5 8 4 13 9 10 13 -2 4 2 8 10 8 20 0 0 -24 -26 -32
-15 -5 -19 -16 -19 -56 0 -28 5 -49 11 -49 5 0 7 5 3 11 -4 8 1 9 16 4 15 -5
20 -4 16 4 -4 6 -1 9 7 5 23 -8 99 57 135 116 25 43 31 62 27 90 -4 27 -3 30
4 15 7 -15 10 -3 10 45 0 48 -3 60 -10 45 -7 -16 -8 -13 -4 12 5 36 -3 66 -15
58 -4 -3 -11 2 -14 11 -3 9 -2 12 5 8 6 -3 4 7 -5 23 -22 45 -92 104 -112 96
-12 -4 -15 -3 -10 5 5 8 1 10 -10 5 -11 -4 -15 -3 -11 4 11 17 -49 33 -117 32
-46 0 -56 -3 -41 -10z m112 -5 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2
13 -5z m-112 -38 c0 -15 -4 -21 -9 -16 -5 5 -6 16 -3 24 9 22 12 20 12 -8z
m33 -7 c-3 -8 -7 -3 -11 10 -4 17 -3 21 5 13 5 -5 8 -16 6 -23z m25 1 c3 -11
1 -18 -4 -14 -5 3 -9 12 -9 20 0 20 7 17 13 -6z m58 -11 c-5 -13 -10 -19 -10
-12 -1 15 10 45 15 40 3 -2 0 -15 -5 -28z m-161 -23 c0 -12 -5 -7 -19 24 -11
24 -11 24 3 6 9 -11 16 -24 16 -30z m285 13 c20 -18 40 -41 46 -53 6 -11 -1
-7 -15 11 -15 17 -39 41 -54 52 -15 11 -24 21 -20 21 4 0 23 -14 43 -31z
m-365 18 c0 -2 -17 -19 -37 -38 l-38 -34 34 38 c33 34 41 42 41 34z m306 -13
c-10 -25 4 -37 20 -17 7 10 13 14 13 8 0 -5 -5 -18 -13 -27 -12 -16 -13 -16
-26 2 -8 10 -18 16 -23 13 -4 -3 -3 4 5 16 15 25 33 28 24 5z m-266 -29 c14
-19 14 -19 -2 -6 -10 7 -18 18 -18 24 0 6 1 8 3 6 1 -2 9 -13 17 -24z m136 7
c-10 -2 -22 0 -28 6 -6 6 0 7 19 4 21 -5 23 -7 9 -10z m-49 -8 c-3 -3 -12 -4
-19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m110 0 c-3 -3 -12 -4 -19 -1 -8 3 -5
6 6 6 11 1 17 -2 13 -5z m-244 -42 c-7 -2 -11 -7 -9 -11 3 -4 -7 -7 -22 -8
-25 -2 -25 -1 -5 7 16 7 20 14 16 31 -6 22 -6 22 13 3 14 -14 16 -20 7 -22z
m74 13 c0 -8 -4 -12 -9 -9 -5 3 -6 10 -3 15 9 13 12 11 12 -6z m218 6 c3 -5 2
-12 -3 -15 -5 -3 -9 1 -9 9 0 17 3 19 12 6z m84 -13 c-16 -31 -16 -31 -22 -8
-3 11 -1 18 4 14 5 -3 9 0 9 5 0 6 5 11 10 11 7 0 7 -8 -1 -22z m-48 -15 c13
-16 12 -17 -3 -4 -17 13 -22 21 -14 21 2 0 10 -8 17 -17z m75 -18 c-11 -8 -24
-15 -30 -15 -5 0 -1 7 10 15 10 8 24 14 29 14 6 0 1 -6 -9 -14z m-382 -13 c3
-5 -1 -9 -9 -9 -8 0 -12 4 -9 9 3 4 7 8 9 8 2 0 6 -4 9 -8z m131 -2 c3 -5 0
-7 -8 -5 -7 3 -25 -5 -40 -19 -15 -14 -27 -20 -27 -15 0 13 41 48 57 49 6 0
15 -4 18 -10z m103 -9 c12 -11 22 -24 22 -30 0 -5 -12 1 -27 15 -15 14 -33 22
-40 19 -8 -2 -11 0 -8 5 9 15 27 12 53 -9z m-303 -11 c13 -6 15 -9 5 -9 -8 0
-22 4 -30 9 -18 12 -2 12 25 0z m36 -31 c-5 -13 -10 -19 -10 -12 -1 15 10 45
15 40 3 -2 0 -15 -5 -28z m449 -4 c-7 -8 -20 -15 -29 -15 -11 0 -8 5 9 14 33
19 35 19 20 1z m-494 -10 c-11 -8 -24 -15 -30 -15 -5 0 -1 7 10 15 10 8 24 14
29 14 6 0 1 -6 -9 -14z m250 -17 c19 -26 10 -52 -16 -52 -18 0 -25 5 -25 19 0
22 13 45 25 45 4 0 12 -6 16 -12z m-243 -25 c3 -5 -5 -8 -18 -8 -13 0 -21 3
-18 8 2 4 10 7 18 7 8 0 16 -3 18 -7z m114 -20 c1 -22 -1 -24 -8 -10 -6 9 -7
22 -4 27 9 14 10 13 12 -17z m235 -9 c-9 -16 -10 -14 -9 8 1 15 6 23 11 18 4
-4 4 -16 -2 -26z m141 9 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18
-5z m-490 -15 c-2 -5 -10 -8 -18 -8 -8 0 -16 3 -18 8 -3 4 5 7 18 7 13 0 21
-3 18 -7z m497 -4 c0 -8 -19 -13 -24 -6 -3 5 1 9 9 9 8 0 15 -2 15 -3z m-490
-18 c0 -2 -9 -6 -20 -9 -11 -3 -18 -1 -14 4 5 9 34 13 34 5z m124 -12 c3 -8 2
-12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z m197 -7 c-10 -9 -11 -8 -5 6 3
10 9 15 12 12 3 -3 0 -11 -7 -18z m144 13 c13 -6 15 -9 5 -9 -8 0 -22 4 -30 9
-18 12 -2 12 25 0z m-55 -19 c0 -5 -8 -19 -18 -31 -14 -18 -19 -19 -19 -7 0 9
4 14 8 11 4 -2 10 5 14 16 7 21 15 27 15 11z m-415 -11 c-27 -12 -43 -12 -25
0 8 5 22 9 30 9 10 0 8 -3 -5 -9z m225 -24 c14 0 33 4 41 9 11 6 11 5 2 -5
-16 -17 -90 -20 -90 -3 0 7 5 9 11 6 5 -4 22 -7 36 -7z m234 -5 c3 -5 -6 -11
-21 -14 -26 -5 -26 -4 -8 9 22 17 22 17 29 5z m-35 -60 c0 -9 -3 -11 -5 -4 -3
7 -11 10 -19 7 -7 -3 -15 -2 -18 3 -3 4 6 9 19 9 16 1 24 -3 23 -15z m-37 -24
c10 -19 9 -20 -4 -10 -8 7 -18 10 -22 6 -4 -4 -4 1 0 12 7 18 6 19 -12 5 -18
-14 -18 -14 -5 2 15 20 26 16 43 -15z m68 20 c0 -2 -12 -14 -27 -28 l-28 -24
24 28 c23 25 31 32 31 24z"
      />
      <path
        d="M1466 802 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z"
      />
      <path
        d="M1304 655 c-11 -8 -14 -15 -6 -15 17 0 15 -30 -3 -30 -8 0 -15 8 -15
17 0 15 -3 14 -22 -5 l-22 -22 21 -22 22 -21 35 35 c39 39 43 50 23 67 -10 8
-19 7 -33 -4z m-33 -72 c13 -16 12 -17 -3 -4 -10 7 -18 15 -18 17 0 8 8 3 21
-13z"
      />
      <path
        d="M1331 579 c-24 -22 -38 -37 -29 -34 8 3 21 -2 29 -12 13 -16 12 -17
-3 -4 -10 7 -18 11 -18 7 0 -15 114 -79 147 -84 61 -8 114 -5 126 7 8 8 5 11
-10 11 -29 0 -84 21 -78 30 2 4 -5 16 -16 26 -19 17 -19 19 -3 31 10 7 13 13
8 13 -6 0 -15 -5 -22 -12 -9 -9 -20 -4 -50 24 l-37 36 -44 -39z m60 14 c13
-16 12 -17 -3 -4 -17 13 -22 21 -14 21 2 0 10 -8 17 -17z m0 -48 c-1 -15 -24
-12 -29 3 -3 9 2 13 12 10 10 -1 17 -7 17 -13z m90 -32 c13 -16 12 -17 -3 -4
-10 7 -18 15 -18 17 0 8 8 3 21 -13z m-3 -31 c2 -7 -3 -12 -12 -12 -9 0 -16 7
-16 16 0 17 22 14 28 -4z"
      />
      <path
        d="M1440 416 c0 -13 6 -27 13 -29 9 -4 9 -8 -1 -15 -16 -11 -12 -54 6
-60 6 -2 12 3 12 12 0 9 -5 16 -12 16 -8 0 -6 6 5 17 16 16 18 16 34 0 11 -11
13 -17 5 -17 -7 0 -12 -7 -12 -16 0 -9 6 -14 13 -12 17 6 21 49 5 60 -10 7
-10 11 0 15 6 2 12 13 12 24 0 21 -17 24 -40 8 -13 -9 -12 -10 3 -5 9 3 17 1
17 -4 0 -6 -9 -10 -21 -10 -16 0 -19 4 -14 20 5 14 2 20 -9 20 -10 0 -16 -9
-16 -24z"
      />
    </g>
  </svg>
);

export const CustomerSupporIcon = createIcon({
  displayName: "CustomerSupportIcon",
  path: (
    <svg fill="currentColor" enableBackground="new 0 0 512 512">
      <g>
        <g>
          <path d="M256,0C131.935,0,31,100.935,31,225c0,13.749,0,120.108,0,122c0,24.813,20.187,45,45,45h17.58    c6.192,17.458,22.865,30,42.42,30c24.813,0,45-20.187,45-45V255c0-24.813-20.187-45-45-45c-19.555,0-36.228,12.542-42.42,30H76    c-5.259,0-10.305,0.915-15,2.58V225c0-107.523,87.477-195,195-195s195,87.477,195,195v17.58c-4.695-1.665-9.741-2.58-15-2.58    h-17.58c-6.192-17.458-22.865-30-42.42-30c-24.813,0-45,20.187-45,45v122c0,24.813,20.187,45,45,45    c4.541,0,8.925-0.682,13.061-1.939C383.45,438.523,366.272,452,346,452h-47.58c-6.192-17.458-22.865-30-42.42-30    c-24.813,0-45,20.187-45,45s20.187,45,45,45c19.555,0,36.228-12.542,42.42-30H346c41.355,0,75-33.645,75-75v-15h15    c24.813,0,45-20.187,45-45c0-1.864,0-108.262,0-122C481,100.935,380.065,0,256,0z M121,255c0-8.271,6.729-15,15-15s15,6.729,15,15    v122c0,8.271-6.729,15-15,15s-15-6.729-15-15V255z M76,270h15v92H76c-8.271,0-15-6.729-15-15v-62C61,276.729,67.729,270,76,270z     M256,482c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S264.271,482,256,482z M391,377c0,8.271-6.729,15-15,15    s-15-6.729-15-15V255c0-8.271,6.729-15,15-15s15,6.729,15,15V377z M451,347c0,8.271-6.729,15-15,15h-15v-92h15    c8.271,0,15,6.729,15,15V347z" />
        </g>
      </g>
    </svg>
  ),
  viewBox: "0 0 512 512",
});

export const RotateLeftIcon = createIcon({
  displayName: "RotateRightIcon",
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 568.017 568.017" }}
    >
      <g>
        <g>
          <path d="M72.553,400.503c11.12,11.119,29.156,11.119,40.282,0l71.849-83.238c11.12-11.119,7.387-20.141-8.342-20.141h-46.444    c-3.929-52.24,14.688-104.059,52.999-142.37c71.194-71.188,187.022-71.188,258.209,0c34.486,34.486,53.477,80.331,53.477,129.102    c0,48.77-18.996,94.616-53.477,129.102c-49.395,49.395-121.219,66.23-187.511,43.936c-19.205-6.488-40.043,3.867-46.512,23.09    c-6.469,19.223,3.868,40.043,23.09,46.512c27.124,9.131,54.903,13.574,82.388,13.574c66.623,0,131.439-26.156,180.461-75.184    c48.36-48.355,74.994-112.645,74.994-181.036c0-68.392-26.634-132.676-74.994-181.036c-99.823-99.823-262.243-99.823-362.06,0    c-52.424,52.424-78.636,122.871-74.75,194.304H14.744c-15.728,0-19.461,9.014-8.341,20.141L72.553,400.503z" />
        </g>
      </g>
    </svg>
  ),
  viewBox: "0 0 568.017 568.017",
});

export const RotateRightIcon = createIcon({
  displayName: "RotateRightIcon",
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 303.597 303.597" }}
    >
      <path
        style={{ fill: "#231F20" }}
        d="M57.866,268.881c25.982,19.891,56.887,30.403,89.369,30.402h0.002c6.545,0,13.176-0.44,19.707-1.308  c39.055-5.187,73.754-25.272,97.702-56.557c14.571-19.033,24.367-41.513,28.329-65.01c0.689-4.084-2.064-7.954-6.148-8.643  l-19.721-3.326c-1.964-0.33-3.974,0.131-5.595,1.284c-1.621,1.153-2.717,2.902-3.048,4.864  c-3.019,17.896-10.49,35.032-21.608,49.555c-18.266,23.861-44.73,39.181-74.521,43.137c-4.994,0.664-10.061,1-15.058,1  c-24.757,0-48.317-8.019-68.137-23.191c-23.86-18.266-39.18-44.73-43.136-74.519c-3.957-29.787,3.924-59.333,22.189-83.194  c21.441-28.007,54.051-44.069,89.469-44.069c24.886,0,48.484,7.996,68.245,23.122c6.55,5.014,12.43,10.615,17.626,16.754  l-36.934-6.52c-1.956-0.347-3.973,0.101-5.604,1.241c-1.631,1.141-2.739,2.882-3.085,4.841l-3.477,19.695  c-0.72,4.079,2.003,7.969,6.081,8.689l88.63,15.647c0.434,0.077,0.869,0.114,1.304,0.114c1.528,0,3.031-0.467,4.301-1.355  c1.63-1.141,2.739-2.882,3.084-4.841l15.646-88.63c0.721-4.079-2.002-7.969-6.081-8.69l-19.695-3.477  c-4.085-0.723-7.97,2.003-8.689,6.082l-6.585,37.3c-7.387-9.162-15.87-17.463-25.248-24.642  c-25.914-19.838-56.86-30.324-89.495-30.324c-46.423,0-89.171,21.063-117.284,57.787C6.454,93.385-3.878,132.123,1.309,171.178  C6.497,210.236,26.583,244.933,57.866,268.881z"
      />
    </svg>
  ),
  viewBox: "0 0 303.597 303.597",
});
export const IdentityIcon = createIcon({
  displayName: "Identity",
  path: (
    <svg fill="currentColor" style={{ enableBackground: "new 0 0 512 512" }}>
      <g>
        <g>
          <circle cx="256" cy="81.455" r="11.636" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M337.455,302.545h-69.818c-6.435,0-11.636,5.213-11.636,11.636s5.201,11.636,11.636,11.636h69.818
    c6.435,0,11.636-5.213,11.636-11.636S343.889,302.545,337.455,302.545z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M442.182,302.545H384c-6.435,0-11.636,5.213-11.636,11.636s5.201,11.636,11.636,11.636h58.182
    c6.435,0,11.636-5.213,11.636-11.636S448.617,302.545,442.182,302.545z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M372.364,256H267.636c-6.435,0-11.636,5.213-11.636,11.636s5.201,11.636,11.636,11.636h104.727
    c6.435,0,11.636-5.213,11.636-11.636S378.799,256,372.364,256z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M360.727,349.091h-93.091c-6.435,0-11.636,5.213-11.636,11.636s5.201,11.636,11.636,11.636h93.091
    c6.435,0,11.636-5.213,11.636-11.636S367.162,349.091,360.727,349.091z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M442.182,256h-23.273c-6.435,0-11.636,5.213-11.636,11.636s5.201,11.636,11.636,11.636h23.273
    c6.435,0,11.636-5.213,11.636-11.636S448.617,256,442.182,256z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M151.273,221.091H128c-19.247,0-34.909,15.663-34.909,34.909v23.273c0,25.67,20.876,46.545,46.545,46.545
    c25.67,0,46.545-20.876,46.545-46.545V256C186.182,236.753,170.519,221.091,151.273,221.091z M162.909,279.273
    c0,12.835-10.438,23.273-23.273,23.273s-23.273-10.438-23.273-23.273V256c0-6.412,5.225-11.636,11.636-11.636h23.273
    c6.412,0,11.636,5.225,11.636,11.636V279.273z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M477.091,116.364h-128c-6.435,0-11.636,5.213-11.636,11.636s5.201,11.636,11.636,11.636h128
    c6.423,0,11.636,5.225,11.636,11.636v302.545c0,6.412-5.213,11.636-11.636,11.636H34.909c-6.412,0-11.636-5.225-11.636-11.636
    V151.273c0-6.412,5.225-11.636,11.636-11.636h128c6.423,0,11.636-5.213,11.636-11.636s-5.213-11.636-11.636-11.636h-128
    C15.663,116.364,0,132.026,0,151.273v302.545c0,19.247,15.663,34.909,34.909,34.909h442.182c19.247,0,34.909-15.663,34.909-34.909
    V151.273C512,132.026,496.337,116.364,477.091,116.364z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M162.909,337.455h-46.545c-32.081,0-58.182,26.1-58.182,58.182v23.273c0,6.423,5.213,11.636,11.636,11.636h139.636
    c6.423,0,11.636-5.213,11.636-11.636v-23.273C221.091,363.555,194.991,337.455,162.909,337.455z M197.818,407.273H81.455v-11.636
    c0-19.247,15.663-34.909,34.909-34.909h46.545c19.247,0,34.909,15.663,34.909,34.909V407.273z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M337.455,162.909H221.091V58.182c0-6.412,5.225-11.636,11.636-11.636h46.545c6.423,0,11.636,5.225,11.636,11.636V128
    c0,6.423,5.201,11.636,11.636,11.636c6.435,0,11.636-5.213,11.636-11.636V58.182c0-19.247-15.663-34.909-34.909-34.909h-46.545
    c-19.247,0-34.909,15.663-34.909,34.909v104.727h-23.273c-6.423,0-11.636,5.213-11.636,11.636s5.213,11.636,11.636,11.636h162.909
    c6.435,0,11.636-5.213,11.636-11.636S343.889,162.909,337.455,162.909z"
          />
        </g>
      </g>
    </svg>
  ),
  viewBox: "0 0 512 512",
});

export const WhatsAppIcon = createIcon({
  path: (
    <path
      fill="currentColor"
      d="M12,.09A12,12,0,0,0,0,12a11.74,11.74,0,0,0,2.14,6.77l-1.35,4a.5.5,0,0,0,.12.51.51.51,0,0,0,.51.13l4.2-1.33A12,12,0,0,0,24,12,12,12,0,0,0,12,.09Zm7.2,16.72a3.91,3.91,0,0,1-3.5,2.09,10.71,10.71,0,0,1-3.45-1A14,14,0,0,1,6.3,12.74c-1.91-2.53-2-4.9-.16-6.86A2.17,2.17,0,0,1,8,5.32a1.54,1.54,0,0,1,1.21.87l.38.92c.28.67.58,1.39.63,1.51a1.1,1.1,0,0,1,0,1,5.14,5.14,0,0,1-1,1.37,12.41,12.41,0,0,0,1.79,2.15,9.06,9.06,0,0,0,2.73,1.63c.28-.36.83-1,1-1.27a1,1,0,0,1,1.34-.36c.38.14,2.51,1.18,2.51,1.18a1.43,1.43,0,0,1,.68.49h0A2,2,0,0,1,19.2,16.81Z"
    />
  ),
  viewBox: "0 0 24 24",
});

export const UploadIcon = createIcon({
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 312.602 312.602" }}
    >
      <path
        style={{ fill: "currentColor" }}
        d="M251.52,137.244c-3.966,0-7.889,0.38-11.738,1.134c-1.756-47.268-40.758-85.181-88.448-85.181
c-43.856,0-80.964,32.449-87.474,75.106C28.501,129.167,0,158.201,0,193.764c0,36.106,29.374,65.48,65.48,65.48h54.782
c4.143,0,7.5-3.357,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5H65.48c-27.835,0-50.48-22.645-50.48-50.48c0-27.835,22.646-50.48,50.48-50.48
c1.367,0,2.813,0.067,4.419,0.206l7.6,0.658l0.529-7.61c2.661-38.322,34.861-68.341,73.306-68.341
c40.533,0,73.51,32.977,73.51,73.51c0,1.863-0.089,3.855-0.272,6.088l-0.983,11.968l11.186-4.367
c5.356-2.091,10.99-3.151,16.747-3.151c25.409,0,46.081,20.672,46.081,46.081c0,25.408-20.672,46.08-46.081,46.08
c-0.668,0-20.608-0.04-40.467-0.08c-19.714-0.04-39.347-0.08-39.999-0.08c-4.668,0-7.108-2.248-7.254-6.681v-80.959l8.139,9.667
c2.667,3.17,7.399,3.576,10.567,0.907c3.169-2.667,3.575-7.398,0.907-10.567l-18.037-21.427c-2.272-2.699-5.537-4.247-8.958-4.247
c-3.421,0-6.686,1.548-8.957,4.247l-18.037,21.427c-2.668,3.169-2.262,7.9,0.907,10.567c1.407,1.185,3.121,1.763,4.826,1.763
c2.137,0,4.258-0.908,5.741-2.67l7.901-9.386v80.751c0,8.686,5.927,21.607,22.254,21.607c0.652,0,20.27,0.04,39.968,0.079
c19.874,0.041,39.829,0.081,40.498,0.081c33.681,0,61.081-27.4,61.081-61.08C312.602,164.644,285.201,137.244,251.52,137.244z"
      />
    </svg>
  ),
  viewBox: "0 0 312.602 312.602",
});

export const PassingTimeIcon = createIcon({
  path: (
    <svg fill="currentColor" enableBackground="new 0 0 511.992 511.992">
      <g id="XMLID_806_">
        <g id="XMLID_386_">
          <path
            id="XMLID_389_"
            d="M511.005,279.646c-4.597-46.238-25.254-89.829-58.168-122.744    c-28.128-28.127-62.556-46.202-98.782-54.239V77.255c14.796-3.681,25.794-17.074,25.794-32.993c0-18.748-15.252-34-34-34h-72    c-18.748,0-34,15.252-34,34c0,15.918,10.998,29.311,25.793,32.993v25.479c-36.115,8.071-70.429,26.121-98.477,54.169    c-6.138,6.138-11.798,12.577-16.979,19.269c-0.251-0.019-0.502-0.038-0.758-0.038H78.167c-5.522,0-10,4.477-10,10s4.478,10,10,10    h58.412c-7.332,12.275-13.244,25.166-17.744,38.436H10c-5.522,0-10,4.477-10,10s4.478,10,10,10h103.184    c-2.882,12.651-4.536,25.526-4.963,38.437H64c-5.522,0-10,4.477-10,10s4.478,10,10,10h44.54    c0.844,12.944,2.925,25.82,6.244,38.437H50c-5.522,0-10,4.477-10,10s4.478,10,10,10h71.166    c9.81,25.951,25.141,50.274,45.999,71.132c32.946,32.946,76.582,53.608,122.868,58.181c6.606,0.652,13.217,0.975,19.819,0.975    c39.022,0,77.548-11.293,110.238-32.581c4.628-3.014,5.937-9.209,2.923-13.837s-9.209-5.937-13.837-2.923    c-71.557,46.597-167.39,36.522-227.869-23.957c-70.962-70.962-70.962-186.425,0-257.388c70.961-70.961,186.424-70.961,257.387,0    c60.399,60.4,70.529,156.151,24.086,227.673c-3.008,4.632-1.691,10.826,2.94,13.833c4.634,3.008,10.826,1.691,13.833-2.941    C504.367,371.396,515.537,325.241,511.005,279.646z M259.849,44.263c0-7.72,6.28-14,14-14h72c7.72,0,14,6.28,14,14s-6.28,14-14,14    h-1.794h-68.413h-1.793C266.129,58.263,259.849,51.982,259.849,44.263z M285.642,99.296V78.263h48.413v20.997    C317.979,97.348,301.715,97.36,285.642,99.296z"
          />
          <path
            id="XMLID_391_"
            d="M445.77,425.5c-2.64,0-5.21,1.07-7.069,2.93c-1.87,1.86-2.931,4.44-2.931,7.07    c0,2.63,1.061,5.21,2.931,7.07c1.859,1.87,4.43,2.93,7.069,2.93c2.63,0,5.2-1.06,7.07-2.93c1.86-1.86,2.93-4.44,2.93-7.07    c0-2.63-1.069-5.21-2.93-7.07C450.97,426.57,448.399,425.5,445.77,425.5z"
          />
          <path
            id="XMLID_394_"
            d="M310.001,144.609c-85.538,0-155.129,69.59-155.129,155.129s69.591,155.129,155.129,155.129    s155.129-69.59,155.129-155.129S395.539,144.609,310.001,144.609z M310.001,434.867c-74.511,0-135.129-60.619-135.129-135.129    s60.618-135.129,135.129-135.129S445.13,225.228,445.13,299.738S384.512,434.867,310.001,434.867z"
          />
          <path
            id="XMLID_397_"
            d="M373.257,222.34l-49.53,49.529c-4.142-2.048-8.801-3.205-13.726-3.205c-4.926,0-9.584,1.157-13.726,3.205    l-22.167-22.167c-3.906-3.905-10.236-3.905-14.143,0c-3.905,3.905-3.905,10.237,0,14.142l22.167,22.167    c-2.049,4.142-3.205,8.801-3.205,13.726c0,17.134,13.939,31.074,31.074,31.074s31.074-13.94,31.074-31.074    c0-4.925-1.157-9.584-3.205-13.726l48.076-48.076v0l1.453-1.453c3.905-3.905,3.905-10.237,0-14.142    S377.164,218.435,373.257,222.34z M310.001,310.812c-6.106,0-11.074-4.968-11.074-11.074s4.968-11.074,11.074-11.074    s11.074,4.968,11.074,11.074S316.107,310.812,310.001,310.812z"
          />
          <path
            id="XMLID_398_"
            d="M416.92,289.86h-9.265c-5.522,0-10,4.477-10,10s4.478,10,10,10h9.265c5.522,0,10-4.477,10-10    S422.442,289.86,416.92,289.86z"
          />
          <path
            id="XMLID_399_"
            d="M212.346,289.616h-9.264c-5.522,0-10,4.477-10,10s4.478,10,10,10h9.264c5.522,0,10-4.477,10-10    S217.868,289.616,212.346,289.616z"
          />
          <path
            id="XMLID_400_"
            d="M310.123,212.083c5.522,0,10-4.477,10-10v-9.264c0-5.523-4.478-10-10-10s-10,4.477-10,10v9.264    C300.123,207.606,304.601,212.083,310.123,212.083z"
          />
          <path
            id="XMLID_424_"
            d="M309.879,387.393c-5.522,0-10,4.477-10,10v9.264c0,5.523,4.478,10,10,10s10-4.477,10-10v-9.264    C319.879,391.87,315.401,387.393,309.879,387.393z"
          />
          <path
            id="XMLID_425_"
            d="M10,351.44c-2.63,0-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07c0,2.64,1.069,5.21,2.93,7.07    s4.44,2.93,7.07,2.93s5.21-1.07,7.069-2.93c1.86-1.86,2.931-4.44,2.931-7.07s-1.07-5.21-2.931-7.07    C15.21,352.51,12.63,351.44,10,351.44z"
          />
        </g>
      </g>
    </svg>
  ),
  viewBox: "0 0 511.992 511.992",
});

export const ErrorIcon = createIcon({
  path: (
    <g fill="currentColor" stroke="none">
      <path
        d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12S18.617,0,12,0z M13.645,5L13,14h-2l-0.608-9 H13.645z M12,20c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2c1.105,0,2,0.895,2,2C14,19.105,13.105,20,12,20z"
        fill="currentColor"
      />
    </g>
  ),
  viewBox: "0 0 24 24",
});

export const PersonIcon = createIcon({
  path: (
    <svg viewBox="-42 0 512 512.002">
      <path d="m210.351562 246.632812c33.882813 0 63.222657-12.152343 87.195313-36.128906 23.972656-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.132812 87.195312 23.976563 23.96875 53.3125 36.125 87.1875 36.125zm0 0" />
      <path d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.308594-10.339844-7.808594-20.550781-13.371094-30.335938-5.773438-10.15625-12.554688-19-20.164063-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.039063 5.339844-10.972656 0-22.085937-1.796876-33.046874-5.339844-11.210938-3.621094-20.296876-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.75-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.605469 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.058594 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.796875-1.023438 19.964844-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.441406 23.734375 65.066406 23.734375h246.53125c26.625 0 48.511719-7.984375 65.0625-23.734375 16.757813-15.945312 25.253906-37.585937 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm0 0" />
    </svg>
  ),
  // viewBox: "0 0 24 24",
});

export const PeopleIcon = createIcon({
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 477.869 477.869" }}
    >
      <g>
        <g>
          <path d="M387.415,233.496c48.976-44.029,52.987-119.424,8.958-168.4C355.991,20.177,288.4,12.546,239.02,47.332    c-53.83-37.99-128.264-25.149-166.254,28.68c-34.859,49.393-27.259,117.054,17.689,157.483    c-55.849,29.44-90.706,87.481-90.453,150.613v51.2c0,9.426,7.641,17.067,17.067,17.067h443.733    c9.426,0,17.067-7.641,17.067-17.067v-51.2C478.121,320.976,443.264,262.935,387.415,233.496z M307.201,59.842    c47.062-0.052,85.256,38.057,85.309,85.119c0.037,33.564-19.631,64.023-50.237,77.799c-1.314,0.597-2.628,1.143-3.959,1.707    c-4.212,1.699-8.556,3.051-12.988,4.045c-0.853,0.188-1.707,0.29-2.577,0.461c-4.952,0.949-9.977,1.457-15.019,1.519    c-2.27,0-4.557-0.171-6.827-0.375c-0.853,0-1.707,0-2.56-0.171c-9.7-1.142-19.136-3.923-27.904-8.226    c-0.324-0.154-0.7-0.137-1.024-0.273c-1.707-0.819-3.413-1.536-4.932-2.458c0.137-0.171,0.222-0.358,0.358-0.529    c7.826-10.056,13.996-21.296,18.278-33.297l0.529-1.434c1.947-5.732,3.459-11.602,4.523-17.562c0.154-0.87,0.273-1.707,0.41-2.645    c0.987-6.067,1.506-12.2,1.553-18.347c-0.049-6.135-0.568-12.257-1.553-18.313c-0.137-0.887-0.256-1.707-0.41-2.645    c-1.064-5.959-2.576-11.83-4.523-17.562l-0.529-1.434c-4.282-12.001-10.453-23.241-18.278-33.297    c-0.137-0.171-0.222-0.358-0.358-0.529C277.449,63.831,292.19,59.843,307.201,59.842z M85.335,145.176    c-0.121-47.006,37.886-85.21,84.892-85.331c22.034-0.057,43.232,8.434,59.134,23.686c0.99,0.956,1.963,1.911,2.918,2.901    c2.931,3.071,5.634,6.351,8.09,9.813c0.751,1.058,1.434,2.185,2.133,3.277c2.385,3.671,4.479,7.523,6.263,11.52    c0.427,0.973,0.751,1.963,1.126,2.935c1.799,4.421,3.215,8.989,4.233,13.653c0.12,0.512,0.154,1.024,0.256,1.553    c2.162,10.597,2.162,21.522,0,32.119c-0.102,0.529-0.137,1.041-0.256,1.553c-1.017,4.664-2.433,9.232-4.233,13.653    c-0.375,0.973-0.7,1.963-1.126,2.935c-1.786,3.991-3.88,7.837-6.263,11.503c-0.7,1.092-1.382,2.219-2.133,3.277    c-2.455,3.463-5.159,6.742-8.09,9.813c-0.956,0.99-1.929,1.946-2.918,2.901c-6.91,6.585-14.877,11.962-23.569,15.906    c-1.382,0.631-2.782,1.212-4.198,1.707c-4.114,1.633-8.347,2.945-12.663,3.925c-1.075,0.239-2.185,0.375-3.277,0.563    c-4.634,0.863-9.333,1.336-14.046,1.417h-1.877c-4.713-0.08-9.412-0.554-14.046-1.417c-1.092-0.188-2.202-0.324-3.277-0.563    c-4.316-0.98-8.55-2.292-12.663-3.925c-1.417-0.563-2.816-1.143-4.198-1.707C105.013,209.057,85.374,178.677,85.335,145.176z     M307.201,418.242H34.135v-34.133c-0.25-57.833,36.188-109.468,90.76-128.614c29.296,12.197,62.249,12.197,91.546,0    c5.698,2.082,11.251,4.539,16.623,7.356c3.55,1.826,6.827,3.908,10.24,6.007c2.219,1.382,4.471,2.731,6.605,4.25    c3.294,2.338,6.4,4.881,9.455,7.492c1.963,1.707,3.908,3.413,5.751,5.12c2.816,2.662,5.461,5.478,8.004,8.363    c1.826,2.082,3.601,4.198,5.291,6.383c2.236,2.867,4.369,5.803,6.349,8.823c1.707,2.56,3.226,5.222,4.727,7.885    c1.707,2.935,3.277,5.871,4.71,8.926c1.434,3.055,2.697,6.4,3.925,9.66c1.075,2.833,2.219,5.649,3.106,8.533    c1.195,3.959,2.031,8.055,2.867,12.151c0.512,2.423,1.178,4.796,1.553,7.253c1.011,6.757,1.53,13.579,1.553,20.412V418.242z     M443.735,418.242h-102.4v-34.133c0-5.342-0.307-10.633-0.785-15.872c-0.137-1.536-0.375-3.055-0.546-4.591    c-0.461-3.772-0.99-7.509-1.707-11.213c-0.307-1.581-0.631-3.169-0.973-4.762c-0.819-3.8-1.769-7.566-2.85-11.298    c-0.358-1.229-0.683-2.475-1.058-3.686c-4.779-15.277-11.704-29.797-20.565-43.127l-0.666-0.973    c-2.935-4.358-6.07-8.573-9.404-12.646l-0.119-0.154c-3.413-4.232-7.117-8.346-11.008-12.237c0.222,0,0.461,0,0.7,0    c4.816,0.633,9.666,0.975,14.524,1.024h0.939c4.496-0.039,8.985-0.33,13.449-0.87c1.399-0.171,2.782-0.427,4.181-0.649    c3.63-0.557,7.214-1.28,10.752-2.167c1.007-0.256,2.031-0.495,3.055-0.785c4.643-1.263,9.203-2.814,13.653-4.642    c54.612,19.127,91.083,70.785,90.829,128.649V418.242z" />
        </g>
      </g>
    </svg>
  ),
  viewBox: "0 0 477.869 477.869",
});
export const LocationIcon = createIcon({
  path: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path
            d="M256,0C161.896,0,85.333,76.563,85.333,170.667c0,28.25,7.063,56.26,20.49,81.104L246.667,506.5
          c1.875,3.396,5.448,5.5,9.333,5.5s7.458-2.104,9.333-5.5l140.896-254.813c13.375-24.76,20.438-52.771,20.438-81.021
          C426.667,76.563,350.104,0,256,0z M256,256c-47.052,0-85.333-38.281-85.333-85.333c0-47.052,38.281-85.333,85.333-85.333
          s85.333,38.281,85.333,85.333C341.333,217.719,303.052,256,256,256z"
          />
        </g>
      </g>
    </svg>
  ),
  // viewBox: "0 0 24 24",
});

export const EducationIcon = createIcon({
  path: (
    <svg
      enable-background="new 0 0 509 509"
      viewBox="0 0 509 509"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m127 114c0-5.514 4.486-10 10-10h1.25l138.75 74 166.875-89-166.875-89-138.75 74h-1.25c-22.057 0-40 17.943-40 40v125h30z" />
        <path d="m382 156-105 56-105-56v47.27l105 52.5 105-52.5c0-7.918 0-34.445 0-47.27z" />
        <path d="m472 434v-30h-135v60l-60-30-60 30v-60h-127.5c-28.995 0-52.5 23.506-52.5 52.5 0 28.995 23.505 52.5 52.5 52.5h382.5v-30h-30v-45z" />
        <path d="m112 344v30h105v-90h-105v30h30v30z" />
        <path d="m427 329c0-24.853-20.147-45-45-45h-45v90h45c24.853 0 45-20.147 45-45z" />
        <path d="m247 415.459 30-15 30 15v-131.459h-60z" />
      </g>
    </svg>
  ),
  // viewBox: "0 0 24 24",
});
export const WorkIcon = createIcon({
  path: (
    <svg
      id="bold"
      enable-background="new 0 0 24 24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m15 6.5c-.552 0-1-.448-1-1v-1.5h-4v1.5c0 .552-.448 1-1 1s-1-.448-1-1v-1.5c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2v1.5c0 .552-.448 1-1 1z" />
      <path d="m12.71 15.38c-.18.07-.44.12-.71.12s-.53-.05-.77-.14l-11.23-3.74v7.63c0 1.52 1.23 2.75 2.75 2.75h18.5c1.52 0 2.75-1.23 2.75-2.75v-7.63z" />
      <path d="m24 7.75v2.29l-11.76 3.92c-.08.03-.16.04-.24.04s-.16-.01-.24-.04l-11.76-3.92v-2.29c0-1.52 1.23-2.75 2.75-2.75h18.5c1.52 0 2.75 1.23 2.75 2.75z" />
    </svg>
  ),
  // viewBox: "0 0 24 24",
});

export const EnterIcon = createIcon({
  path: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 382.975 382.975"
    >
      <polygon
        points="358.098,296.762 271.885,210.548 271.885,282.008 54.877,282.008 54.877,0 24.877,0 24.877,312.008 
	271.885,312.008 271.885,382.975 "
      />
    </svg>
  ),
});

export const ArchiveIcon = createIcon({
  path: (
    <svg
      id="Layer_1"
      version="1.1"
      viewBox="1 -1 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title />
      <g>
        <path d="M76,29.5H26c-5,0-9,4-9,9v43c0,5,4,9,9,9h50c5,0,9-4,9-9v-43C85,33.5,81,29.5,76,29.5z M65.3,53.8c0,1.7-1.3,3-3,3H39.7   c-1.7,0-3-1.3-3-3v-7.6c0-1.7,1.3-3,3-3s3,1.3,3,3v4.6h16.6v-4.6c0-1.7,1.3-3,3-3s3,1.3,3,3V53.8z" />
        <path d="M26,24.5h50c1.7,0,3-1.3,3-3s-1.3-3-3-3H26c-1.7,0-3,1.3-3,3S24.3,24.5,26,24.5z" />
        <path d="M31,13.5h40c1.7,0,3-1.3,3-3s-1.3-3-3-3H31c-1.7,0-3,1.3-3,3S29.3,13.5,31,13.5z" />
      </g>
    </svg>
  ),
});

export const MoreIcon = createIcon({
  path: (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 384 384"
    >
      <g>
        <g>
          <circle cx="192" cy="42.667" r="42.667" />
        </g>
      </g>
      <g>
        <g>
          <circle cx="192" cy="192" r="42.667" />
        </g>
      </g>
      <g>
        <g>
          <circle cx="192" cy="341.333" r="42.667" />
        </g>
      </g>
    </svg>
  ),
});

export const EmptyShelfIcon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      width="200px"
      height="200px"
      viewBox="0 0 511.999 511.999"
    >
      <g>
        <polygon
          fill="#c2c1be"
          points="391.39,115.337 384.846,119.14 384.846,465.672 401.642,475.37 408.186,471.566 
   408.186,125.034 	"
        />
        <polygon
          fill="#c2c1be"
          points="401.642,128.837 408.186,125.034 408.186,471.566 401.642,475.37 	"
        />
      </g>
      <polygon
        fill="#c2c1be"
        points="384.846,119.14 391.39,115.337 408.186,125.034 401.642,128.837 "
      />
      <polygon
        fill="#c2c1be"
        points="401.642,128.837 401.642,475.37 384.846,465.672 384.846,119.14 "
      />
      <g>
        <polygon
          fill="#c2c1be"
          points="192.925,0 186.382,3.802 186.382,350.335 203.177,360.032 209.721,356.229 209.721,9.697 	
   "
        />
        <polygon
          fill="#c2c1be"
          points="203.177,13.5 209.721,9.697 209.721,356.229 203.177,360.032 	"
        />
      </g>
      <polygon
        fill="#c2c1be"
        points="186.382,3.802 192.925,0 209.721,9.697 203.177,13.5 "
      />
      <polygon
        fill="#c2c1be"
        points="203.177,13.5 203.177,360.032 186.382,350.335 186.382,3.802 "
      />
      <path
        fill="#c2c1be"
        d="M338.955,173.84l-6.303-3.639l-0.057,20.203c-0.017,5.976-4.26,8.394-9.459,5.391l-171.77-99.17
 c-5.2-3.002-9.415-10.304-9.399-16.278l0.057-20.203l-6.303-3.639l-0.057,20.203c-0.028,9.967,7.006,22.152,15.681,27.16
 l171.769,99.171c8.674,5.008,15.755,0.973,15.783-8.994L338.955,173.84z"
      />
      <path
        fill="#c2c1be"
        d="M401.463,128.836L186.245,3.766l-77.567,44.784c-2.698,1.558-4.874,5.327-4.865,8.427
 c0.004,1.517,0.538,2.616,1.424,3.132l215.217,125.07c-0.024-0.014-0.045-0.032-0.068-0.047c0.579,0.365,1.316,0.475,2.161,0.275
 l79.021-18.855L401.463,128.836z"
      />
      <polygon
        fill="#c2c1be"
        points="323.896,173.62 108.678,48.549 186.245,3.766 401.463,128.836 "
      />
      <path
        fill="#c2c1be"
        d="M320.454,185.178L105.237,60.107c-0.887-0.515-1.42-1.614-1.424-3.132
 c-0.008-3.1,2.168-6.869,4.865-8.427l215.218,125.07c-2.698,1.558-4.874,5.327-4.865,8.427
 C319.034,183.564,319.568,184.663,320.454,185.178z"
      />
      <path
        fill="#c2c1be"
        d="M401.463,128.836l0.107,37.714l-79.021,18.855c-2.079,0.494-3.511-0.87-3.517-3.358
 c-0.008-3.1,2.168-6.869,4.865-8.427L401.463,128.836z"
      />
      <path
        fill="#c2c1be"
        d="M338.955,327.246l-6.303-3.639l-0.057,20.203c-0.017,5.976-4.26,8.394-9.459,5.391l-171.77-99.17
 c-5.2-3.002-9.415-10.304-9.399-16.278l0.057-20.203l-6.303-3.638l-0.057,20.203c-0.028,9.967,7.006,22.152,15.681,27.16
 l171.769,99.171c8.674,5.008,15.755,0.973,15.783-8.994L338.955,327.246z"
      />
      <path
        fill="#c2c1be"
        d="M401.463,282.242l-215.218-125.07l-77.567,44.784c-2.698,1.558-4.874,5.327-4.865,8.427
 c0.004,1.517,0.538,2.616,1.424,3.132l215.217,125.07c-0.024-0.014-0.045-0.032-0.068-0.047c0.579,0.365,1.316,0.475,2.161,0.275
 l79.021-18.855L401.463,282.242z"
      />
      <polygon
        fill="#c2c1be"
        points="323.896,327.025 108.678,201.955 186.245,157.171 401.463,282.242 "
      />
      <path
        fill="#c2c1be"
        d="M320.454,338.584L105.237,213.512c-0.887-0.515-1.42-1.614-1.424-3.132
 c-0.008-3.1,2.168-6.869,4.865-8.427l215.218,125.07c-2.698,1.558-4.874,5.327-4.865,8.427
 C319.034,336.97,319.568,338.069,320.454,338.584z"
      />
      <path
        fill="#c2c1be"
        d="M401.463,282.242l0.107,37.714l-79.021,18.855c-2.079,0.494-3.511-0.87-3.517-3.358
 c-0.008-3.1,2.168-6.869,4.865-8.427L401.463,282.242z"
      />
      <path
        fill="#c2c1be"
        d="M338.955,480.651l-6.303-3.639l-0.057,20.203c-0.017,5.976-4.26,8.394-9.459,5.391l-171.769-99.171
 c-5.2-3.002-9.415-10.304-9.399-16.278l0.057-20.203l-6.303-3.639l-0.057,20.203c-0.028,9.967,7.006,22.152,15.681,27.16
 l171.769,99.171c8.674,5.008,15.755,0.973,15.783-8.994L338.955,480.651z"
      />
      <path
        fill="#c2c1be"
        d="M401.463,435.647l-215.218-125.07l-77.567,44.784c-2.698,1.558-4.874,5.327-4.865,8.427
 c0.004,1.517,0.538,2.616,1.424,3.132l215.217,125.07c-0.024-0.014-0.045-0.032-0.068-0.047c0.579,0.365,1.316,0.475,2.161,0.275
 l79.021-18.855L401.463,435.647z"
      />
      <polygon
        fill="#c2c1be"
        points="323.896,480.431 108.678,355.361 186.245,310.577 401.463,435.647 "
      />
      <path
        fill="#c2c1be"
        d="M320.454,491.989L105.237,366.918c-0.887-0.515-1.42-1.614-1.424-3.132
 c-0.008-3.1,2.168-6.869,4.865-8.427l215.218,125.07c-2.698,1.558-4.874,5.327-4.865,8.427
 C319.034,490.375,319.568,491.474,320.454,491.989z"
      />
      <path
        fill="#c2c1be"
        d="M401.463,435.647l0.107,37.714l-79.021,18.855c-2.079,0.494-3.511-0.87-3.517-3.358
 c-0.008-3.1,2.168-6.869,4.865-8.427L401.463,435.647z"
      />
    </svg>
  );
};

export const Subjectsicon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="25.08px"
      height="25.079px"
      viewBox="0 0 335.08 335.079"
    >
      <g>
        <g>
          <path
            d="M311.175,115.775c-1.355-10.186-1.546-27.73,7.915-33.621c0.169-0.108,0.295-0.264,0.443-0.398
			c7.735-2.474,13.088-5.946,8.886-10.618l-114.102-34.38L29.56,62.445c0,0-21.157,3.024-19.267,35.894
			c1.026,17.89,6.637,26.676,11.544,31l-15.161,4.569c-4.208,4.672,1.144,8.145,8.88,10.615c0.147,0.138,0.271,0.293,0.443,0.401
			c9.455,5.896,9.273,23.438,7.913,33.626c-33.967,9.645-21.774,12.788-21.774,12.788l7.451,1.803
			c-5.241,4.736-10.446,13.717-9.471,30.75c1.891,32.864,19.269,35.132,19.269,35.132l120.904,39.298l182.49-44.202
			c0,0,12.197-3.148-21.779-12.794c-1.366-10.172-1.556-27.712,7.921-33.623c0.174-0.105,0.301-0.264,0.442-0.396
			c7.736-2.474,13.084-5.943,8.881-10.615l-7.932-2.395c5.29-3.19,13.236-11.527,14.481-33.183
			c0.859-14.896-3.027-23.62-7.525-28.756l15.678-3.794C332.949,128.569,345.146,125.421,311.175,115.775z M158.533,115.354
			l30.688-6.307l103.708-21.312l15.451-3.178c-4.937,9.036-4.73,21.402-3.913,29.35c0.179,1.798,0.385,3.44,0.585,4.688
			L288.14,122.8l-130.897,32.563L158.533,115.354z M26.71,147.337l15.449,3.178l99.597,20.474l8.701,1.782l0,0l0,0l26.093,5.363
			l1.287,40.01L43.303,184.673l-13.263-3.296c0.195-1.25,0.401-2.89,0.588-4.693C31.44,168.742,31.651,156.373,26.71,147.337z
			 M20.708,96.757c-0.187-8.743,1.371-15.066,4.52-18.28c2.004-2.052,4.369-2.479,5.991-2.479c0.857,0,1.474,0.119,1.516,0.119
			l79.607,25.953l39.717,12.949l-1.303,40.289L39.334,124.07l-5.88-1.647c-0.216-0.061-0.509-0.103-0.735-0.113
			C32.26,122.277,21.244,121.263,20.708,96.757z M140.579,280.866L23.28,247.98c-0.217-0.063-0.507-0.105-0.733-0.116
			c-0.467-0.031-11.488-1.044-12.021-25.544c-0.19-8.754,1.376-15.071,4.519-18.288c2.009-2.052,4.375-2.479,5.994-2.479
			c0.859,0,1.474,0.115,1.519,0.115c0,0,0.005,0,0,0l119.316,38.908L140.579,280.866z M294.284,239.459
			c0.185,1.804,0.391,3.443,0.591,4.693l-147.812,36.771l1.292-40.01l31.601-6.497l4.667,1.129l17.492-5.685l80.631-16.569
			l15.457-3.18C293.261,219.146,293.466,231.517,294.284,239.459z M302.426,185.084c-0.269,0.006-0.538,0.042-0.791,0.122
			l-11.148,3.121l-106.148,29.764l-1.298-40.289l34.826-11.359l84.327-27.501c0.011-0.005,4.436-0.988,7.684,2.315
			c3.144,3.214,4.704,9.537,4.52,18.28C313.848,184.035,302.827,185.053,302.426,185.084z"
          />
        </g>
      </g>
    </svg>
  );
};
export const DiscountIcon = () => {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="currentColor"
      enableBackground="new 0 0 512 512"
    >
      <g>
        <path d="m256 512c-68.38 0-132.668-26.628-181.02-74.98s-74.98-112.64-74.98-181.02 26.629-132.667 74.98-181.02 112.64-74.98 181.02-74.98 132.668 26.628 181.02 74.98 74.98 112.64 74.98 181.02-26.629 132.667-74.98 181.02-112.64 74.98-181.02 74.98zm0-480c-123.514 0-224 100.486-224 224s100.486 224 224 224 224-100.486 224-224-100.486-224-224-224z" />
        <path d="m256 240c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40c0 8.836 7.163 16 16 16s16-7.164 16-16c0-34.201-23.978-62.888-56-70.186v-17.814c0-8.836-7.163-16-16-16s-16 7.164-16 16v17.814c-32.022 7.298-56 35.985-56 70.186 0 39.701 32.299 72 72 72 22.056 0 40 17.944 40 40s-17.944 40-40 40-40-17.944-40-40c0-8.836-7.163-16-16-16s-16 7.164-16 16c0 34.201 23.978 62.888 56 70.186v17.814c0 8.836 7.163 16 16 16s16-7.164 16-16v-17.814c32.022-7.298 56-35.985 56-70.186 0-39.701-32.299-72-72-72z" />
      </g>
    </svg>
  );
};

export const SendMessageIcon = createIcon({
  path: (
    <svg fill="currentColor" enableBackground="new 0 0 496.009 496.009">
      <path d="m475.015.815-464 151.617c-13.104 4.282-14.999 22.106-3.073 29.04l175.35 101.963c5.532 3.217 12.446 2.829 17.582-.986l49.292-36.606-36.606 49.292c-3.814 5.137-4.202 12.052-.986 17.583l101.963 175.35c6.942 11.936 24.762 10.02 29.041-3.073l151.617-464c4.067-12.459-7.782-24.234-20.18-20.18zm-150.766 440.297-78.712-135.365 94.913-127.805c4.729-6.37 4.078-15.243-1.532-20.853-5.609-5.61-14.484-6.262-20.853-1.532l-127.805 94.914-135.364-78.713 400.087-130.733zm-156.258-90.468-106.238 106.237c-6.248 6.247-16.379 6.249-22.627 0-6.249-6.248-6.249-16.379 0-22.627l106.238-106.237c6.25-6.247 16.381-6.249 22.627 0 6.249 6.248 6.249 16.379 0 22.627zm-140.349 4.02c-6.249-6.249-6.249-16.379 0-22.627l41.92-41.921c6.248-6.249 16.379-6.249 22.627 0 6.249 6.249 6.249 16.379 0 22.627l-41.92 41.921c-6.247 6.247-16.379 6.248-22.627 0zm178.25 49.154c6.249 6.248 6.249 16.379 0 22.627l-41.921 41.92c-3.124 3.125-7.219 4.687-11.313 4.687-14.127 0-21.421-17.207-11.313-27.314l41.921-41.92c6.247-6.249 16.378-6.249 22.626 0z" />
    </svg>
  ),
  viewBox: "0 0 496.009 496.009",
});
export const WalletIcon = createIcon({
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 512 512" }}
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path d="M438.154,44.308H73.846C33.127,44.308,0,77.435,0,118.154v275.692c0,40.719,33.127,73.846,73.846,73.846h364.308    c40.719,0,73.846-33.127,73.846-73.846V118.154C512,77.435,478.873,44.308,438.154,44.308z M482.462,300.308H374.154    c-24.431,0-44.308-19.876-44.308-44.308s19.876-44.308,44.308-44.308h108.308V300.308z M482.462,182.154H374.154    c-40.719,0-73.846,33.127-73.846,73.846s33.127,73.846,73.846,73.846h108.308v64c0,24.431-19.876,44.308-44.308,44.308H73.846    c-24.431,0-44.308-19.876-44.308-44.308V118.154c0-24.431,19.876-44.308,44.308-44.308h364.308    c24.431,0,44.308,19.876,44.308,44.308V182.154z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M393.846,241.231h-19.692c-8.157,0-14.769,6.613-14.769,14.769c0,8.157,6.613,14.769,14.769,14.769h19.692    c8.157,0,14.769-6.613,14.769-14.769C408.615,247.843,402.003,241.231,393.846,241.231z" />
        </g>
      </g>
    </svg>
  ),
});

export const BankIcon = createIcon({
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 512.001 512.001" }}
      viewBox="0 0 512.001 512.001"
    >
      <g>
        <path d="M424.001,420.001h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S428.419,420.001,424.001,420.001z" />
        <path d="M504.001,420.001h-16v-24c0-4.418-3.582-8-8-8h-16v-192h16c4.418,0,8-3.582,8-8v-24h16c3.81,0,7.091-2.687,7.843-6.422   c0.751-3.735-1.235-7.482-4.749-8.956l-248-104c-1.979-0.83-4.209-0.83-6.188,0l-248,104c-3.514,1.473-5.5,5.22-4.749,8.956   c0.751,3.735,4.033,6.422,7.843,6.422h16v24c0,4.418,3.582,8,8,8h16v192h-16c-4.418,0-8,3.582-8,8v24h-16c-4.418,0-8,3.582-8,8v32   c0,4.418,3.582,8,8,8h496c4.418,0,8-3.582,8-8v-32C512.001,423.582,508.419,420.001,504.001,420.001z M448.001,388.001h-24v-192h24   V388.001z M392.001,388.001v-192h16v192H392.001z M320.001,388.001v-192h16v192H320.001z M248.001,388.001v-192h16v192H248.001z    M176.001,388.001v-192h16v192H176.001z M104.001,388.001v-192h16v192H104.001z M136.001,196.001h24v192h-24V196.001z    M208.001,196.001h24v192h-24V196.001z M280.001,196.001h24v192h-24V196.001z M352.001,196.001h24v192h-24V196.001z    M40.001,164.001h335.997c4.418,0,8-3.582,8-8s-3.582-8-8-8H47.764l208.236-87.325l208.236,87.325h-8.238c-4.418,0-8,3.582-8,8   s3.582,8,8,8h16.001v16h-16h-40h-32h-40h-32h-40h-32h-40h-32h-40h-32h-40h-16V164.001z M64.001,196.001h24v192h-24V196.001z    M496.001,452.001h-480v-16h360c4.418,0,8-3.582,8-8s-3.582-8-8-8h-336v-16h16h40h32h40h32h40h32h40h32h40h32h40h16v16h-16.002   c-4.418,0-8,3.582-8,8s3.582,8,8,8h40.002V452.001z" />
        <path d="M408.003,164.001H424c4.418,0,8-3.582,8-8s-3.582-8-8-8h-15.997c-4.418,0-8,3.582-8,8S403.584,164.001,408.003,164.001z" />
        <path d="M280.001,100.001c-4.418,0-8,3.582-8,8c0,8.822-7.178,16-16,16c-8.822,0-16-7.178-16-16s7.178-16,16-16   c4.418,0,8-3.582,8-8s-3.582-8-8-8c-17.645,0-32,14.355-32,32s14.355,32,32,32s32-14.355,32-32   C288.001,103.582,284.419,100.001,280.001,100.001z" />
      </g>
    </svg>
  ),
});

export const CreditCardIcon = createIcon({
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 55.107 55.107" }}
      viewBox="0 0 55.107 55.107"
    >
      <g>
        <g>
          <path
            style={{ fill: "currentColor" }}
            d="M50,4.899H10.753c-2.816,0-5.108,2.292-5.108,5.108v6.711H5.108C2.292,16.719,0,19.01,0,21.826    V45.1c0,2.816,2.292,5.107,5.108,5.107h39.248c1.365,0,2.647-0.531,3.612-1.496c0.965-0.965,1.496-2.248,1.495-3.613v-6.711H50    c2.816,0,5.107-2.291,5.107-5.106V10.007C55.107,7.191,52.816,4.899,50,4.899z M7.645,11.575h45.462v2.882H7.645V11.575z     M10.753,6.899H50c1.714,0,3.107,1.394,3.107,3.108v0.567H7.645v-0.567C7.645,8.293,9.039,6.899,10.753,6.899z M47.463,45.099    c0,0.831-0.322,1.612-0.909,2.199c-0.587,0.587-1.367,0.91-2.198,0.91H5.108C3.394,48.208,2,46.814,2,45.102V21.826    c0-1.713,1.394-3.107,3.108-3.107h39.248c1.714,0,3.107,1.394,3.107,3.107V45.099z M50,36.389h-0.537V21.826    c0-2.816-2.291-5.107-5.107-5.107H7.646v-1.262h45.462v17.825C53.107,34.994,51.714,36.389,50,36.389z"
          />
          <path
            style={{ fill: "currentColor" }}
            d="M42.242,37.229H6.645c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h35.597    c0.276,0,0.5-0.224,0.5-0.5S42.518,37.229,42.242,37.229z"
          />
          <path
            style={{ fill: "currentColor" }}
            d="M9.668,33.308h3.603c0.865,0,1.679-0.337,2.291-0.948s0.948-1.425,0.948-2.29v-2.397    c0-1.785-1.453-3.237-3.238-3.237H9.669c-1.785,0-3.237,1.452-3.237,3.237v2.398C6.431,31.855,7.883,33.308,9.668,33.308z     M9.829,28.049c-0.064,0.302-0.105,0.623-0.105,0.965c0,0.188,0.013,0.37,0.033,0.546H7.432v-1.512L9.829,28.049L9.829,28.049z     M11.471,26.899c0.188,0,0.384,0.149,0.553,0.4h-1.105C11.087,27.048,11.283,26.899,11.471,26.899z M12.345,28.049    c0.076,0.287,0.125,0.61,0.125,0.965c0,0.192-0.017,0.373-0.042,0.546h-1.913c-0.024-0.174-0.042-0.354-0.042-0.546    c0-0.355,0.049-0.678,0.125-0.965H12.345z M15.509,29.561h-2.323c0.02-0.177,0.033-0.358,0.033-0.546    c0-0.342-0.042-0.664-0.105-0.965h2.396v1.511H15.509z M11.471,31.128c-0.276,0-0.569-0.316-0.766-0.818h1.532    C12.04,30.812,11.747,31.128,11.471,31.128z M7.455,30.311h2.459c0.231,0.76,0.657,1.32,1.182,1.502v0.496H9.668    C8.516,32.308,7.576,31.431,7.455,30.311z M13.271,32.308h-1.425v-0.496c0.525-0.182,0.95-0.742,1.182-1.502h2.458    c-0.054,0.507-0.267,0.978-0.631,1.343C14.432,32.076,13.869,32.308,13.271,32.308z M15.471,27.299h-2.598    c-0.246-0.543-0.604-0.937-1.027-1.083v-0.778h1.425C14.377,25.437,15.291,26.243,15.471,27.299z M9.668,25.437h1.428v0.778    c-0.423,0.146-0.781,0.54-1.027,1.083h-2.6C7.649,26.243,8.563,25.437,9.668,25.437z"
          />
        </g>
      </g>
    </svg>
  ),
});

export const LeftQuoteIcon = createIcon({
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 95.333 95.332" }}
    >
      <g>
        <g>
          <path
            d="M30.512,43.939c-2.348-0.676-4.696-1.019-6.98-1.019c-3.527,0-6.47,0.806-8.752,1.793
			c2.2-8.054,7.485-21.951,18.013-23.516c0.975-0.145,1.774-0.85,2.04-1.799l2.301-8.23c0.194-0.696,0.079-1.441-0.318-2.045
			s-1.035-1.007-1.75-1.105c-0.777-0.106-1.569-0.16-2.354-0.16c-12.637,0-25.152,13.19-30.433,32.076
			c-3.1,11.08-4.009,27.738,3.627,38.223c4.273,5.867,10.507,9,18.529,9.313c0.033,0.001,0.065,0.002,0.098,0.002
			c9.898,0,18.675-6.666,21.345-16.209c1.595-5.705,0.874-11.688-2.032-16.851C40.971,49.307,36.236,45.586,30.512,43.939z"
          />
          <path
            d="M92.471,54.413c-2.875-5.106-7.61-8.827-13.334-10.474c-2.348-0.676-4.696-1.019-6.979-1.019
			c-3.527,0-6.471,0.806-8.753,1.793c2.2-8.054,7.485-21.951,18.014-23.516c0.975-0.145,1.773-0.85,2.04-1.799l2.301-8.23
			c0.194-0.696,0.079-1.441-0.318-2.045c-0.396-0.604-1.034-1.007-1.75-1.105c-0.776-0.106-1.568-0.16-2.354-0.16
			c-12.637,0-25.152,13.19-30.434,32.076c-3.099,11.08-4.008,27.738,3.629,38.225c4.272,5.866,10.507,9,18.528,9.312
			c0.033,0.001,0.065,0.002,0.099,0.002c9.897,0,18.675-6.666,21.345-16.209C96.098,65.559,95.376,59.575,92.471,54.413z"
          />
        </g>
      </g>
    </svg>
  ),
  viewBox: "0 0 95.333 95.332",
});

export const GiftBoxIcon = createIcon({
  path: (
    <svg fill="currentColor" style={{ enableBackground: "new 0 0 512 512" }}>
      <g>
        <g>
          <path d="M449.603,177.797l-50.188-18.267c18.146-14.994,25.894-38.777,20.339-61.377c-10.917-44.403-65.056-61.259-99.26-31.022    l-34.652,30.632l-6.855-45.94c-6.778-45.229-59.141-66.989-95.978-40.039c-18.419,13.475-28.217,36.704-23.872,60.29    l-47.318-17.222C88.539,46.377,62.7,58.425,54.225,81.708l-20.49,56.297c-2.829,7.773,1.179,16.369,8.953,19.197    c3.153,1.147,230.742,83.983,234.084,85.199c-9.472,0-216.903,0-226.029,0c-8.272,0-14.978,6.706-14.978,14.978v209.688    c0,24.776,20.157,44.933,44.933,44.933H200.52h59.911h119.822c24.776,0,44.933-20.157,44.933-44.933V296.42l11.587,4.218    c7.737,2.818,16.355-1.147,19.197-8.952l20.491-56.297C484.933,212.106,472.886,186.271,449.603,177.797z M185.541,482.045H80.697    c-8.259,0-14.978-6.719-14.978-14.978v-194.71h119.822V482.045z M245.452,482.045h-29.955V272.357h29.955V482.045z     M340.333,89.575c17.375-15.361,44.805-6.744,50.331,15.731c5.893,23.963-17.269,44.741-40.451,36.317    c-19.718-7.177-28.958-10.54-48.703-17.727L340.333,89.575z M200.695,35.962c18.72-13.694,45.237-2.582,48.668,20.303l7.68,51.445    c-5.528-2.012-43.262-15.747-48.699-17.725C185.16,81.542,180.781,50.528,200.695,35.962z M207.751,185.402L67.007,134.175    l15.368-42.222c2.825-7.761,11.438-11.775,19.198-8.952c15.75,5.732,121.811,44.335,126.668,46.103L207.751,185.402z     M264.049,205.894L235.9,195.648l20.491-56.297l28.149,10.246L264.049,205.894z M395.229,467.067    c0,8.259-6.719,14.978-14.978,14.978H275.408V272.357h83.666l36.156,13.16V467.067z M448.309,225.142l-15.367,42.223    l-140.744-51.227l20.491-56.297l126.669,46.103C447.119,208.769,451.134,217.382,448.309,225.142z" />
        </g>
      </g>
    </svg>
  ),
  viewBox: "0 0 512 512",
});

export const HomeworkIcon = createIcon({
  path: (
    <svg fill="currentColor">
      <path d="m100 113c0-11.046875 8.953125-20 20-20h272c11.046875 0 20 8.953125 20 20s-8.953125 20-20 20h-272c-11.046875 0-20-8.953125-20-20zm312 80c0-11.046875-8.953125-20-20-20h-272c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h272c11.046875 0 20-8.953125 20-20zm-292 60c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h92c11.046875 0 20-8.953125 20-20s-8.953125-20-20-20zm374.441406 156.589844c23.378906 23.378906 23.378906 61.441406-.015625 84.835937-11.695312 11.695313-27.0625 17.546875-42.425781 17.546875s-30.730469-5.851562-42.425781-17.546875l-109.367188-109.570312c-2.4375-2.441407-4.199219-5.46875-5.117187-8.792969l-22.363282-80.722656c-1.945312-7.03125.085938-14.5625 5.308594-19.65625 5.21875-5.089844 12.796875-6.941406 19.777344-4.820313l78.726562 23.914063c3.152344.957031 6.019532 2.675781 8.34375 5.007812zm-162.210937-49.273438 73.515625 73.652344 28.289062-28.289062-73.925781-74.089844-39.128906-11.886719zm133.910156 77.542969-3.851563-3.863281-28.285156 28.285156 3.867188 3.875c7.785156 7.785156 20.472656 7.785156 28.269531-.015625 7.800781-7.796875 7.800781-20.484375 0-28.28125zm-34.140625-437.859375h-352c-44.113281 0-80 35.886719-80 80v352c0 44.113281 35.886719 80 80 80h245c11.046875 0 20-8.953125 20-20s-8.953125-20-20-20h-245c-22.054688 0-40-17.945312-40-40v-352c0-22.054688 17.945312-40 40-40h352c22.054688 0 40 17.945312 40 40v246c0 11.046875 8.953125 20 20 20s20-8.953125 20-20v-246c0-44.113281-35.886719-80-80-80zm0 0" />
    </svg>
  ),
  viewBox: "0 0 512 512",
});

export const TrophyIcon = createIcon({
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 490.8 490.8" }}
    >
      <g>
        <path
          d="M396.55,0H95.15v45.1H8.05v74c0,53.2,43.3,96.4,96.4,96.4h6.7c20.4,40.7,58.7,70.8,104.6,80.1v60.1h-34.6
  c-10.7,0-19.3,8.6-19.3,19.3v25.3h-29.6v90.5h226.3v-90.5h-29.6V375c0-10.7-8.6-19.3-19.3-19.3h-34.6v-60
  c46.2-9.1,84.8-39.4,105.4-80.3h5.9c53.2,0,96.4-43.3,96.4-96.4V45h-86.3V0H396.55z M56.85,119.1V93.9h38.3V148
  c0,6.1,0.4,12.1,1.1,18C73.95,162.1,56.85,142.6,56.85,119.1z M284.65,405v48.5h-78.3V405H284.65z M353.85,148
  c0,59.6-48.5,108-108,108s-108.1-48.5-108.1-108V42.7h216.1V148z M434.05,93.9v25.2c0,23.2-16.6,42.5-38.6,46.7
  c0.7-5.9,1.1-11.8,1.1-17.8V93.9H434.05z M185.35,131.1c-5.1-4.3-2.4-12.7,4.3-13.1l35.5-2.6l13.4-32.9c2.5-6.2,11.3-6.2,13.8,0
  l13.4,32.9l35.5,2.6c6.7,0.5,9.4,8.8,4.3,13.1l-27.2,22.9l8.5,34.5c1.6,6.5-5.5,11.7-11.2,8.1l-30.2-18.6l-30.2,18.8
  c-5.7,3.5-12.8-1.6-11.2-8.1l8.5-34.5L185.35,131.1z"
        />
      </g>
    </svg>
  ),
  viewBox: "0 0 490.8 490.8",
});

export const NigerianFlagIcon = createIcon({
  path: (
    <svg style={{ enableBbackground: "new 0 0 512 512" }}>
      <path
        style={{ fill: "#73AF00" }}
        d="M38.345,88.273C17.167,88.273,0,105.44,0,126.618v258.759c0,21.177,17.167,38.345,38.345,38.345  h132.322V88.273H38.345z"
      />
      <rect
        x="170.67"
        y="88.277"
        style={{ fill: "#F5F5F5" }}
        width="170.67"
        height="335.45"
      />
      <path
        style={{ fill: "#73AF00" }}
        d="M473.655,88.273H341.333v335.448h132.322c21.177,0,38.345-17.167,38.345-38.345V126.618  C512,105.44,494.833,88.273,473.655,88.273z"
      />
    </svg>
  ),
  viewBox: "0 0 512 512",
});

export const FastIcon = createIcon({
  path: (
    <g fill="currentColor">
      <path d="M20.444,9.27A.5.5,0,0,0,20,9H12.624L14.488.606a.5.5,0,0,0-.895-.4l-10,14A.5.5,0,0,0,4,15h7.376L9.512,23.39a.5.5,0,0,0,.895.4l10-14A.5.5,0,0,0,20.444,9.27Z" />
    </g>
  ),
  viewBox: "0 0 24 24",
});

export const ShareIcon = createIcon({
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 481.6 481.6" }}
    >
      <g>
        <path
          d="M381.6,309.4c-27.7,0-52.4,13.2-68.2,33.6l-132.3-73.9c3.1-8.9,4.8-18.5,4.8-28.4c0-10-1.7-19.5-4.9-28.5l132.2-73.8
  c15.7,20.5,40.5,33.8,68.3,33.8c47.4,0,86.1-38.6,86.1-86.1S429,0,381.5,0s-86.1,38.6-86.1,86.1c0,10,1.7,19.6,4.9,28.5
  l-132.1,73.8c-15.7-20.6-40.5-33.8-68.3-33.8c-47.4,0-86.1,38.6-86.1,86.1s38.7,86.1,86.2,86.1c27.8,0,52.6-13.3,68.4-33.9
  l132.2,73.9c-3.2,9-5,18.7-5,28.7c0,47.4,38.6,86.1,86.1,86.1s86.1-38.6,86.1-86.1S429.1,309.4,381.6,309.4z M381.6,27.1
  c32.6,0,59.1,26.5,59.1,59.1s-26.5,59.1-59.1,59.1s-59.1-26.5-59.1-59.1S349.1,27.1,381.6,27.1z M100,299.8
  c-32.6,0-59.1-26.5-59.1-59.1s26.5-59.1,59.1-59.1s59.1,26.5,59.1,59.1S132.5,299.8,100,299.8z M381.6,454.5
  c-32.6,0-59.1-26.5-59.1-59.1c0-32.6,26.5-59.1,59.1-59.1s59.1,26.5,59.1,59.1C440.7,428,414.2,454.5,381.6,454.5z"
        />
      </g>
    </svg>
  ),
  viewBox: "0 0 481.6 481.6",
});

export const HeartOutlineIcon = createIcon({
  path: (
    <svg fill="currentColor" style={{ enableBackground: "new 0 0 512 512" }}>
      <path
        d="M474.644,74.27C449.391,45.616,414.358,29.836,376,29.836c-53.948,0-88.103,32.22-107.255,59.25
    c-4.969,7.014-9.196,14.047-12.745,20.665c-3.549-6.618-7.775-13.651-12.745-20.665c-19.152-27.03-53.307-59.25-107.255-59.25
    c-38.358,0-73.391,15.781-98.645,44.435C13.267,101.605,0,138.213,0,177.351c0,42.603,16.633,82.228,52.345,124.7
    c31.917,37.96,77.834,77.088,131.005,122.397c19.813,16.884,40.302,34.344,62.115,53.429l0.655,0.574
    c2.828,2.476,6.354,3.713,9.88,3.713s7.052-1.238,9.88-3.713l0.655-0.574c21.813-19.085,42.302-36.544,62.118-53.431
    c53.168-45.306,99.085-84.434,131.002-122.395C495.367,259.578,512,219.954,512,177.351
    C512,138.213,498.733,101.605,474.644,74.27z M309.193,401.614c-17.08,14.554-34.658,29.533-53.193,45.646
    c-18.534-16.111-36.113-31.091-53.196-45.648C98.745,312.939,30,254.358,30,177.351c0-31.83,10.605-61.394,29.862-83.245
    C79.34,72.007,106.379,59.836,136,59.836c41.129,0,67.716,25.338,82.776,46.594c13.509,19.064,20.558,38.282,22.962,45.659
    c2.011,6.175,7.768,10.354,14.262,10.354c6.494,0,12.251-4.179,14.262-10.354c2.404-7.377,9.453-26.595,22.962-45.66
    c15.06-21.255,41.647-46.593,82.776-46.593c29.621,0,56.66,12.171,76.137,34.27C471.395,115.957,482,145.521,482,177.351
    C482,254.358,413.255,312.939,309.193,401.614z"
      />
    </svg>
  ),
  viewBox: "0 0 512 512",
});

export const LogoutIcon = createIcon({
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 491.213 491.213" }}
    >
      <g>
        <path
          d="M318.713,73.106c-32.723,0-64.571,9.208-92.103,26.628c-26.772,16.94-48.365,40.868-62.445,69.196l26.865,13.353
  c24.272-48.838,73.198-79.176,127.683-79.176c78.575,0,142.5,63.925,142.5,142.5s-63.925,142.5-142.5,142.5
  c-54.484,0-103.41-30.338-127.683-79.176l-26.865,13.353c14.08,28.328,35.673,52.256,62.445,69.196
  c27.531,17.42,59.38,26.628,92.103,26.628c95.117,0,172.5-77.383,172.5-172.5S413.83,73.106,318.713,73.106z"
        />
        <polygon
          points="318.713,260.606 318.713,230.606 57.426,230.606 91.819,196.213 70.606,175 0,245.607 70.606,316.213 91.819,295 
  57.425,260.606 	"
        />
      </g>
    </svg>
  ),
  viewBox: "0 0 491.213 491.213",
});

export const CheckMarkIcon = createIcon({
  path: (
    <svg
      fill="currentColor"
      style={{ enableBackground: "new 0 0 305.002 305.002" }}
    >
      <g>
        <g>
          <path
            d="M152.502,0.001C68.412,0.001,0,68.412,0,152.501s68.412,152.5,152.502,152.5c84.089,0,152.5-68.411,152.5-152.5
    S236.591,0.001,152.502,0.001z M152.502,280.001C82.197,280.001,25,222.806,25,152.501c0-70.304,57.197-127.5,127.502-127.5
    c70.304,0,127.5,57.196,127.5,127.5C280.002,222.806,222.806,280.001,152.502,280.001z"
          />
          <path
            d="M218.473,93.97l-90.546,90.547l-41.398-41.398c-4.882-4.881-12.796-4.881-17.678,0c-4.881,4.882-4.881,12.796,0,17.678
    l50.237,50.237c2.441,2.44,5.64,3.661,8.839,3.661c3.199,0,6.398-1.221,8.839-3.661l99.385-99.385
    c4.881-4.882,4.881-12.796,0-17.678C231.269,89.089,223.354,89.089,218.473,93.97z"
          />
        </g>
      </g>
    </svg>
  ),
  viewBox: "0 0 305.002 305.002",
});

export const CheckBadgeIcon = createIcon({
  path: (
    <g fill="currentColor">
      <path d="M22.718,10.35,20.88,8.872a1.092,1.092,0,0,1-.4-.971l.255-2.345a2.091,2.091,0,0,0-2.307-2.308L16.08,3.5a1.093,1.093,0,0,1-.971-.4L13.631,1.263a2.157,2.157,0,0,0-3.262,0L8.891,3.1a1.086,1.086,0,0,1-.971.4L5.575,3.248A2.091,2.091,0,0,0,3.267,5.555L3.522,7.9a1.087,1.087,0,0,1-.4.971L1.282,10.35a2.092,2.092,0,0,0,0,3.262L3.12,15.09a1.088,1.088,0,0,1,.4.971l-.255,2.345a2.091,2.091,0,0,0,2.307,2.308l2.346-.255a1.092,1.092,0,0,1,.971.4L10.369,22.7a2.092,2.092,0,0,0,3.262,0l1.478-1.838a1.093,1.093,0,0,1,.971-.4l2.345.255a2.091,2.091,0,0,0,2.308-2.307l-.255-2.346a1.086,1.086,0,0,1,.4-.971l1.838-1.478a2.092,2.092,0,0,0,0-3.262ZM12.4,15.048a1.785,1.785,0,0,1-2.663.19L7.293,12.8a1,1,0,1,1,1.414-1.414l2.251,2.251,3.909-5.211a1,1,0,1,1,1.6,1.2Z" />
    </g>
  ),
  viewBox: "0 0 24 24",
});
